import SettingsIcon from '@material-ui/icons/Settings';
import React from 'react';

export const Translate = {
    /********Specific*******/
    app_name: "نام وب سایت",
    auto_pay_off: "تسویه اتوماتیک خاموش",
    auto_pay_on: "تسویه اتوماتیک روشن",
    appName: "پنل کاربری",
    check: "کنترل",
    cancle: "انصراف",
    goToPage: "تغییر صفحه",
    marketerSummery: "فعالیت‌های بازاریاب",
    pageNumber: "شماره صفحه",
    ticketDesc: "در صورت نیاز به پشتیبانی، پیگیری سفارش و ارتباط با مدیریت، تیکت ثبت کنید. همکاران ما با شما در ارتباط خواهند بود.",
    marketerShops: "لیست فروشگاه‌ها",
    marketerShopsDesc: "در این جدول لیست فروشگاه‌هایی که شما را به عنوان بازاریاب خود معرفی کرده‌اند و وضعیت تایید آن توسط ادمین پنجره را مشاهده می‌فرمایید.",
    marketerOrdersDesc: "در این جدول لیست سفارش‌هایی که به مرحله تسویه با فروشگاه رسیده‌اند و مبلغ پورسانت شما در آن لحاظ شده است را مشاهده می‌فرمایید.",
    welcomeToMarketerDashboard: "با داشبورد بازاریابی پنجره خوش آمدید.",
    depositReal: "واریز",
    findShops: "یافتن فروشگاه",
    findShopsDesc: "کتاب فروشی‌های مختلف را پیدا کنید",
    submitShops: "ثبت فروشندگان",
    submitShopsDesc: "با درج کد شما به عنوان بازاریاب پورسانت بگیرید",
    withdrawAmount: "مبلغ برداشت",
    custom_title: "تیتر محصول (سئو)",
    learn_cards: "کارت‌های آموزشی",
    app_card: "کارت‌ آموزشی",
    marketer_income: "درآمد بازاریابی",
    total_orders: "تعداد سفارش‌ها",
    total_shops: "تعداد فروشگاه‌ها",
    marketer_mode: "نمایش بازاریابان",
    export: "دانلود نتایج",
    marketerDetails: "اطلاعات بازاریاب",
    player: "پخش کتاب صوتی",
    addOneNewProduct: "ایجاد یک کتاب جدید",
    marketerInfo: "اطلاعات بازاریاب",
    marketerInfoDesc: "در صورتی که توسط یک بازاریاب با پنجره آشنا شده‌اید، کد یکتا بازاریاب را در این قسمت وارد کنید.",
    sendMessageToBuyer: "پیام به خریدار",
    fillAllFields: "لطفا همه فیلد‌ها را تکمیل نمایید",
    incomeSharing: "تقسیم درآمد",
    marketer_id: "کد یکتا بازاریاب",
    sharingPercent: "درصد تقسیم",
    seen: "دیده شده",
    post: "پست (پرداخت آنلاین)",
    courier: "پیک (پس کرایه)",
    makeSeen: "دیده شد",
    unSeen: "جدید",
    rejectProduct: "عدم تایید",
    rejectShop: "عدم تایید",
    disabledProduct: "غیرفعال",
    rejectProductS: "ثبت عدم تایید",
    rejectShopS: "ثبت عدم تایید",
    rejection_reason: "دلیل عدم تایید",
    productRejected: "عدم تایید ثبت شد.",
    shopRejected: "عدم تایید ثبت شد.",
    rejectProductTitle: "آیا از انجام این کار مطمئنید؟",
    rejectProductDesc: "پس از ثبت عدم تایید برای فروشنده جهت اطلاع رسانی پیامک ارسال می‌شود و دلیل نوشته شده توسط تیکت برای او ارسال می‌شود. (همچنین در صورت ثبت عدم تایید، تغییرات ذخیره نشده حذف می‌شوند) ",
    youCantUploadMoreThan15Files: "امکان آپلود همزمان بیش از ۱۵ فایل وجود ندارد",
    calculatedDuration: "مدت زمان کل توسط سیستم محاسبه می‌شود.",
    persianOnly: "این فیلد را به فارسی تکمیل کنید",
    incomeSharingTitle: "تقسیم درآمد بین فروشندگان",
    incomeSharingDesc: "از این قسمت می‌توانید درآمد حاصل از یک کتاب را با یک فروشگاه دیگر تقسیم کنید.",
    percentError: "درصد باید بین ۱ تا ۹۹ باشد",
    marketer_commission_source: "محل دریافت پورسانت",
    websiteSource: "کارمزد وبسایت",
    shopSource: "درآمد فروشنده",
    marketer_commission_rate: "درصد دریافت پورسانت",
    removeISBN: "حذف شابک",
    doYouWanaRISBN: "شابک حذف شود؟",
    welcomeGft: "مخصوص سفارش اول",
    shipment_at: "تاریخ ثبت کد رهگیری",
    sendMessageToUser: "ارسال پیام به این کاربر",
    transferCourier: "ارسال با پیک (پس کرایه)",
    unconfirmed_product: "در انتظار بررسی",
    searchInBook: "جستجو در کتاب",
    bulkPricing: "قیمت‌گذاری گروهی فروشگاه",
    noMediaFound: "رسانه‌ای یافت نشد!",
    maxHeightBanner: "ارتفاع بنر حداکثر ۲۰۰ پیکسل",
    welcome_discount: "درصد تخفیف خوش‌آمدگویی",
    bulkPricingShort: "قیمت‌گذاری گروهی",
    moreData: "اطلاعات بیشتر",
    hasRent: "امکان کرایه کتاب وجود دارد",
    betweenUsers: "ارتباط کاربران",
    rentHelpText: "راهنمای کرایه کتاب",
    rentHelpTextDesc: "با فعال کردن این گزینه امکان کرایه کتاب خود را صادر می‌کنید، در لیست زیر نرخ کرایه کتاب را مشاهده می‌کنید.",
    insertVideo: "درج ویدیو",
    walletNumber: "شماره کیف‌پول",
    addDirectory: "افزودن پوشه",
    directoryName: "نام پوشه",
    moveFilesToDirectory: "انتقال به پوشه",
    moveHere: "انتقال به اینجا",
    editDirectory: "ویرایش نام پوشه",
    currentDirectory: "پوشه انتخاب شده",
    removeDirectory: "حذف پوشه",
    viewBook: "مشاهده کتاب",
    ebookFormats: "فرمت‌های PDF و EPUB قابل آپلود می‌باشند",
    rawFormats: "فرمت‌های PDF، DOC، DOCX، ZIP قابل آپلود می‌باشند",
    audioFormats: "فرمت‌ mp3 قابل آپلود می‌باشد",
    bookUsageExpired: "مدت کرایه کتاب پایان یافت!",
    adminBuiltAVersion: "نسخه ایجاد شده توسط پنجره به خریداران نمایش داده می‌شود!",
    atLeast5Character: "حداقل ۵ حرف",
    sync: "همگام سازی",
    highlight: "هایلایت",
    darkMode: "حالت شب",
    changeFontSize: "سایز فونت",
    tocList: "سرفصل‌ها",
    tocLists: "فهرست مطالب",
    backToLibrary: "بازگشت به کتابخانه",
    zoomIn: "بزرگ‌نمایی",
    zoomOut: "کوچک‌نمایی",
    selections: "ذخیره شده",
    changeShopOwner: "تغییر مالکیت فروشگاه",
    imageProperWidthHeight: "سایز",
    most_selling_product: "پرفروش‌ترین کتاب‌ها",
    most_selling_shop: "پرفروش‌ترین فروشندگان",
    most_visited_product: "پربازدیدترین کتاب‌ها",
    most_reviewed_product: "پردیدگاه‌ترین کتاب‌ها",
    pixel: "پیکسل",
    completeOrderFree: "تکمیل سفارش (رایگان)",
    imageProperWeight: "حداکثر حجم",
    changeShopOwnerDesc: "جهت تغییر مالکیت فروشگاه، کاربر مد نظر را انتخاب کنید. ",
    changeShopOwnerDesc2: "در نظر داشته باشید با تغییر مالکیت فروشگاه، مالکیت محصولات و قیمت‌گذاری ها هم منتقل می‌شود اما موجودی کیف پول کاربر منتقل نمی‌شود. ",
    changeShopOwnerDesc3: "کاربر انتخاب شده نباید فروشگاه داشته باشد. ",
    chooseNewOwner: "انتخاب مالک جدید",
    showProductsInHome: "نمایش محصولات این دسته در صفحه اصلی",
    sentTicket: "ارسال شده",
    episodesIndex: "مشاهده قسمت‌ها",
    aparatUrl: "لینک صفحه آپارات",
    aparatInsert: "درج ویدیو آپارات",
    aparatSample: "https://www.aparat.com/v/wB7Gp مانند",
    productUrl: "شناسه یکتا کتاب",
    productInsert: "درج کتاب",
    productSample: "EP_1002 مانند",
    doThisShopHasUniqueCommission: "این فروشگاه درصد کارمزد متفاوت دارد",
    imgPreview: "پیشنمایش تصویر",
    transactions: "تراکنش‌ها",
    epName: "نام اپیزود",
    action: "فعالیت",
    episodes: "اپیزودها",
    chapters: "فصل‌ها",
    removeEpisode: "حذف اپیزود",
    removeChapter: "حذف فصل",
    payment_link: "شناسه واریز یا لینک پرداخت",
    manageRents: "مدیریت نرخ کرایه",
    rents: "نرخ‌های کرایه",
    rent_name: "نام مدل",
    rent_percent: "درصد کرایه",
    duration: "مدت زمان (روز)",
    discountDate: "تاریخ اتمام تخفیف",
    pleaseAddPreviousEpFile: "لطفا ابتدا فایل اپیزود قبل را بارگذاری نمایید",
    viewInDigitalLibrary: "مشاهده در کتابخانه دیجیتال",
    addNewEpisode: "افزودن اپیزود",
    addNewChapter: "افزودن فصل",
    emptyLibrary: "کتابخانه شما خالی است، برای خرید کتاب از دکمه زیر استفاده کنید.",
    chooseRelatedProduct: "کتاب کاغذی مرتبط",
    related_product: "کتاب کاغذی مرتبط",
    groupConfirmation: "تایید موارد انتخاب شده",
    worked_commission: "کارمزد کتب دست دوم",
    new_commission: "کارمزد کتب نو",
    sendToTest: "ارسال جهت بررسی",
    bannerImage: "تصویر بنر",
    worked_status: "وضعیت ظاهری کتاب",
    bannerImageMobile: "تصویر بنر در موبایل",
    valid_until: "قابل استفاده تا",
    episode: "اپیزود",
    chapter: "فصل",
    code: "کد",
    library: "کتابخانه",
    digitalLibrary: "کتابخانه دیجیتال",
    codeFile: "کد فایل",
    webmail: "Webmail",
    has_multi_cover: "تعداد جلد",
    singleCover: "تک جلدی",
    multiCover: "چند جلدی",
    cover_count:  "تعداد جلد",
    show_email: "نمایش ایمیل در پروفایل فروشگاه",
    show_address: "نمایش آدرس در پروفایل فروشگاه",
    show_phone: "نمایش تلفن ثابت در پروفایل فروشگاه",
    show_mobile: "نمایش موبایل در پروفایل فروشگاه",
    viewTutorial: "مشاهده آموزش",
    book_revision_requests: "درخواست ویرایش کتاب",
    walletInventory: "موجودی کیف پول",
    ticketIsClosed: "این تیکت بسته شده است",
    ibanVerificationFailed: "نتیجه استعلام شماره شبا صحیح نمی باشد",
    mobileVerificationFailed: "شماره موبایل و کد ملی تطابق ندارند",
    changeMobileOrEmail:"تغییر شماره موبایل یا ایمیل",
    changeMobileOrEmailDesc:"در صورت تغییر اطلاعات، نیاز به تایید مجدد موبایل می‌باشد",
    anotherUserHasThisInfo:"اطلاعات وارد شده قبلا توسط کاربر دیگری ثبت شده است",
    closeTicket:"بستن تیکت",
    ticketClosed:"تیکت بسته شد",
    closed:"بسته شده",
    openTicket:"در جریان",
    manageCategoriesOrder: "مدیریت ترتیب دسته‌بندی‌ها",
    editSubMenuOrder: "ترتیب زیر دسته",
    noCategoryFound: "دسته‌ای یافت نشد!",
    youAreEditingParentCategoriesOrder: "شما درحال مرتب‌سازی دسته‌بندی‌های اصلی هستید!",
    youAreEditingCategoriesOrder: "درحال مرتب‌سازی زیر دسته:‌ ",
    youAreEditingParentCategoriesOrderDesc: "با کلیک روی دکمه ویرایش زیرمجموعه هر دسته را مرتب کنید.",
    today: "امروز",
    this_week: "این هفته",
    this_month: "این ماه",
    custom_date: "بازه انتخابی",
    allDate: "همه زمان‌ها",
    paymentAction: "عملیات پرداخت",
    read: "خوانده شده",
    blog: "وبلاگ",
    book: "کتاب",
    back: "بازگشت",
    banks: "لیست بانک‌ها",
    pricing_status: "وضعیت موجودی",
    pricing_status_virtual: "وضعیت فروش",
    present_pricing: "موجود",
    sold_pricing: "اتمام موجودی",
    present_pricing_virtual: "فروش فعال",
    unlimited: "بدون محدودیت",
    sold_pricing_virtual: "فروش غیر فعال",
    soon_pricing: "به ‌زودی",
    free_pricing: "رایگان",
    requestSupport: "درخواست پشتیبانی",
    addAddressFirst: "نیاز به ثبت آدرس",
    addISBN: "افرودن شابک",
    addISBNToProduct: "افرودن کد شابک به کتاب",
    inside_price: "هزینه ارسال درون استان",
    outside_price: "هزینه ارسال بین‌ استانی",
    publishStatusChanged: "وضعیت انتشار کتاب تغییر کرد!",
    viewReceipt: "برچسب پستی",
    pleaseCompleteYourInfoFirst: "لطفا ابتدا اطلاعات حساب کاربری خود را تکمیل نمایید",
    completeInfo: "تکمیل اطلاعات کاربری",
    withoutError: "آماده بارگذاری",
    approved: "تایید",
    not_approved: "خطا",
    festivalsHelp: "در این بخش می‌توانید شرایط جشنواره‌های فعال سایت را مشاهده کنید و در صورت علاقه محصولات خود را در جشنواره مشارکت دهید!",
    pricingHelp: "در این بخش می‌توانید کتاب‌هایی را که قیمت‌گذاری نکرده‌اید مشاهده و قیمت‌گذاری نمایید!",
    pricingEditHelp: "در این بخش می‌توانید کتاب‌هایی را که قبلا قیمت‌گذاری کرده‌اید مشاهده و ویرایش نمایید!",
    didYouNowYouCanMakeAShop: "شما می‌توانید با تکمیل اطلاعات خود، فروشگاه آنلاین کتاب خود را بسازید.",
    tryNow: "همین حالا اقدام کنید",
    becomeSeller: "فروشنده شوید",
    seller_dashboard_notic: "از طریق پنل فروشگاه می‌توانید بخش‌های مرتبط با فروش و محصولات خود را مدیریت کنید و از بخش پنل کاربر می‌توانید خرید‌ها و سفارشات خود را مشاهده کنید! ",
    shop_unique_key: "کد یونیک فروشگاه",
    shop_link_hint: "از این لینک می‌توانید در شبکه‌های اجتماعی و فضای مجازی خود استفاده نمایید.",
    staredInputsAreRequired: "تکمیل اطلاعات ستاره‌دار الزامی است!",
    importFromExcel: "درج گروهی کتاب‌ها از اکسل",
    importHasProblem: "درج گروهی با مشکل مواجه شد!",
    pleaseDownloadTemplateFirst: "لطفا ابتدا قالب اکسل را دانلود نمایید و پس از تکمیل در بخش بعدی بارگذاری نمایید",
    importHint: "لطفا در وارد کردن اطلاعات در فایل اکسل به نکات زیر توجه نمایید",
    importHint1: "در فیلد وضعیت فقط عدد 1 (محصول نو) یا 2 (محصول دست‌دوم) بنویسید",
    importHint2: "در صورتی که می‌خواهید فروش عمده را فعال کنیددر فیلد مربوطه فقط عدد 1 بنویسید",
    importHint3: "کد تصاویر و فایل‌ها را از بخش رسانه ها مشاهده نمایید.",
    importHint4: "قبل از تایید مطمئن شوید مبالغ به تومان است.",
    downloadExcel: "دانلود فایل قالب اکسل",
    importFile: "فایل تکمیل شده را در این قسمت آپلود نمایید",
    uploadImportFile: "درج محصولات",
    allProductsImported: "همه محصولات ایجاد شدند!",
    allProductsImportedDry: "محصولات بررسی و مورد تایید می‌باشند. می‌توانید آن هارا درج کنید",
    theseErrorsHappendsInimporting: "خطاهای زیر درزمان درج محصولات به وجود آمد",
    pleaseSolveErrorsAndRetry: "لطفا خطاها را رفع کرده و مجدد تلاش نمایید.",
    buy: "خرید",
    package: "پکیج",
    managePackagesOrders: "پکیج‌های خریداری شده",
    buyFromWallet: "خرید (پرداخت از کیف پول)",
    free: "رایگان",
    productToBuy: "محصول جدید می‌توانید ایجاد کنید.",
    productLimit: "محدودیت ایجاد محصول",
    managePackages: "مدیریت پکیج‌ها",
    packageName: "نام پکیج",
    product_quantity: "تعداد محصول",
    makePackage: "ایجاد پکیج",
    editPackage: "ویرایش پکیج",
    active_users: "کاربران فعال",
    registered_books: "کتاب‌های موجود",
    transfer_price: "هزینه حمل و نقل",
    succsessfull_sales: "فروش موفق",
    online_users: "کاربران آنلاین",
    adminMenu: "پنل مدیریت",
    admin_wallet_is_low: "موجودی پنل ادمین کم می‌باشد!",
    wholesale: "خرید عمده",
    normal_limit: "محدودیت ایجاد محصول فروشنده عادی",
    physical_store_limit: "محدودیت ایجاد محصول فروشگاه فیزیکی",
    virtual_store_limit: "محدودیت ایجاد محصول فروشگاه مجازی",
    distribution_limit: "محدودیت ایجاد محصول شرکت پخش",
    publisher_limit: "محدودیت ایجاد محصول انتشارات",
    limit_hint: "در صورت خالی بودن فیلد بدون محدودیت در نظر گرفته می‌شود",
    decrease_from: "کسر مبلغ تخفیف از",
    shopDiscounts: "کد‌های تخفیف فروشگاه",
    pleaseChooseWeightLimitsFirst: "هیچ بازه وزنی ایجاد نشده است!",
    transferInfo: "در صورتی که وزن مرسوله در بازه‌های انتخابی شما نباشد، هزینه ارسال بر مبنای بیشترین وزن مشخص شده توسط شما محاسبه می‌شود.",
    transfer_type_definition: "نحوه محاسبه هزینه ارسال",
    transferPricingTitle: "هزینه ارسال سفارش‌های خود را مشخص نمایید",
    deaSupplier: "فروشنده گرامی",
    transferPricingTitleDesc: "در این قسمت می‌توانید نحوه محاسبه هزینه ارسال سفارش‌های خود را از بین ارسال رایگان، هزینه ثابت، متغیر بر مبنای میزان خرید و بر مبنای وزن مرسوله مشخص نمایید.",
    free_transfer_type: "ارسال رایگان",
    fixed_transfer_type: "هزینه ثابت",
    transfer_fixed_price: "هزینه ثابت ارسال سفارش",
    transfer_free_limit: "حداقل مبلغ سفارش",
    transfer_free_limit_desc: "حداقل مبلغ سفارش جهت ارسال رایگان را مشخص نمایید",
    transfer_free_limit_fixed_desc: "در صورتی که مبلغ سفارش کمتر از حداقل مبلغ مشخص شده باشد، هزینه ارسال بر مبنای وزن مرسوله محاسبه می‌شود.",
    condition_transfer_type: "شرطی بر مبنای مبلغ سفارش",
    weight_transfer_type: "بر مبنای وزن مرسوله",
    new_normal: "کتاب نو / فروشنده عادی",
    new_virtual: "کتاب نو / فروشنده مجازی",
    new_physical: "کتاب نو / فروشنده فیزیکی",
    new_publisher: "کتاب نو / فروشنده انتشارات",
    new_distribution: "کتاب نو / فروشنده شرکت پخش",
    worked_normal: "کتاب دست دوم / فروشنده عادی",
    worked_virtual: "کتاب دست دوم / فروشنده مجازی",
    worked_physical: "کتاب دست دوم / فروشنده فیزیکی",
    worked_publisher: "کتاب دست دوم / فروشنده انتشارات",
    worked_distribution: "کتاب دست دوم / فروشنده شرکت پخش",
    manageCommissions: "مدیریت کارمزد‌ها",
    supplierMenu: "پنل فروشگاه",
    userMenu: "پنل کاربر",
    marketerMenu: "پنل بازاریاب",
    shopLink: "لینک فروشگاه شما",
    RequestSupplierPage: "درخواست ایجاد فروشگاه",
    welcomeToRequestToSupplier: "به بخش درخواست ایجاد فروشگاه خوش آمدید",
    welcomeToRequestToSupplierDesc: "جهت ادامه فرایند ثبت درخواست فروشگاه ابتدا قوانین ثبت فروشگاه را مطالعه نمایید.",
    nextLevel: "مرحله بعد",
    youAreViewingReview: "شما درحال ثبت دیدگاه برای کتاب زیر می‌باشید.",
    isNotExist: "موجود نیست!",
    pleaseChooseABrand: "لطفا یک ناشر انتخاب کنید",
    pleaseChooseAnImage: "لطفا یک تصویر انتخاب کنید",
    average_rate: "میانگین امتیاز",
    removeReview: "حذف دیدگاه",
    manageReview: "مدیریت دیدگاه",
    saveCode: "ذخیره کد",
    writeAReview: "ثبت دیدگاه",
    manageReviews: "مدیریت دیدگاه‌ها",
    reviewEdited: "دیدگاه ویرایش شد",
    reviewAdded: "دیدگاه ثبت شد",
    publish_quality: "کیفیت تالیف",
    translate_quality: "کیفیت ترجمه",
    pack_quality: "کیفیت بسته بندی و ارسال",
    print_quality: "کیفیت چاپ",
    vendor_quality: "امتیاز فروشنده",
    backToProduct: "بازگشت به صفحه کتاب",
    revisionSent: "درخواست ویرایش اطلاعات کتاب ارسال شد",
    revisionSentFailed: "مشکلی در ارسال اطلاعات وجود دارد.",
    sendRevision: "ویرایش اطلاعات کتاب",
    mergeRevision: "ادغام اطلاعات کتاب",
    revisionAlertTitle: "لطفا دقت کنید",
    revisionAlertText: "لطفا در وارد کردن اطلاعات خود دقت کنید، همجنین در صورتی که ناشر، سال چاپ و یا هر مورد دیگری از کتاب شما با این کتاب تفاوت دارد، یک کتاب تازه ایجاد کنید.",
    shopIsNotConfirmed: "فروشگاه این کتاب تایید نشده است.",
    createProduct: "ساخت کتاب تازه",
    youDidntMadeAnyChanges: "شما هیج تغییری در اطلاعات کتاب نداده‌اید",
    files: "فایل‌های مرتبط",
    manageRevisions: "مدیریت تغییر محصولات",
    myDetails: "اطلاعات من",
    todaySales: "فروش امروز",
    packagesSales: "فروش پکیج",
    productLabel: "لیبل کتاب",
    maxGallerySizeIs9: "تعداد آیتم مجاز ۹ عدد است.",
    writeYourCodehere: "کد خود را اینجا بنویسید",
    initialInformationToMakeProduct: "اطلاعات اولیه ایجاد محصول",
    wholeSaleInventoryLessThanInventory: "این تعداد از کل موجودی بیشتر است!",
    labelColor: "رنگ لیبل",
    checkProduct: "بررسی محصول",
    isbnShouldOnlyContainsNumber: "کد شابک را به صورت اعداد پشت سرهم وارد کنید!",
    isbnIsExistHead: "این کد شابک در سایت موجود است!",
    isbnIsExist: " شما می‌توانید برای آن قیمت‌ گذاری کنید، ولی امکان ویرایش اطلاعات آن را ندارید!",
    isbnDescription: "کتاب‌های دارای کد شابک، در نمایش به کاربران از اولویت بیشتری برخوردارند!",
    isbn: "کد شابک",
    isbnOfPhysical: "کد شابک کتاب کاغذی مرجع",
    goToPricing: "قیمت‌گذاری این کتاب",
    productDoesntHaveISBN: "این کتاب کد شابک ندارد!",
    wrongISBN: "کد شابک اشتباه است!",
    wrongYear: "لطفا سال را به صورت صحیح و ۴ رقمی وارد کنید",
    bookInformation: "اطلاعات کتاب",
    isbnHelper: "اعداد را پشت سر هم بدون خط فاصله وارد کنید",
    pageCover: "تصویر کاور صفحه",
    siteInformation: "اطلاعات اصلی سایت",
    contactInformation: "اطلاعات تماس سایت",
    changePrimaryColor: "تغییر رنگ اصلی",
    changeSecondaryColor: "تغییر رنگ ثانویه",
    viewPage: "مشاهده صفحه",
    changeColor: "تغییر رنگ",
    editMenu: "ویرایش آیتم منو",
    saveChanges: "ذخیره تغییرات",
    site_logo: "لوگو سایت",
    favicon: "نمادک سایت (FavIcon)",
    square_logo: "لوگو مربع",
    page_header: "هدر صفحات داخلی",
    youCantDeletePermenantpages: "امکان حذف صفحات اصلی وجود ندارد!",
    addMenu: "افزودن آیتم منو",
    content: "نوشته",
    submit: "ثبت",
    custom_css: "کد CSS اضافی",
    custom_js: "کد Java Script اضافی",
    custom_head: "کد اضافه در <head> سایت",
    custom_body: "کد اضافه در <body> سایت",
    custom_code: "کد اضافی",
    main_phone: "شماره تلفن سایت",
    main_email: "ایمیل سایت",
    main_mobile: "شماره موبایل سایت",
    main_address: "آدرس",
    customCodeTitle: "کد‌های مورد نیاز خود را اضافه کنید!",
    customCodeText: "در این قسمت می‌توانید کد‌های مورد نیاز خود را در بخش‌های مختلف سایتتان اضافه و آن‌ها را سفارشی‌سازی کنید!",
    facebook: "لینک Facebook",
    linkedin: "لینک LinkedIn",
    pinterest: "لینک Pinterest",
    youtube: "لینک Youtube",
    bale: "لینک بله",
    instagram: "لینک Instagram",
    twitter: "لینک X",
    whatsapp: "لینک Whatsapp",
    telegram: "لینک Telegram",
    headerAndFooter: "مدیریت هدر و فوتر",
    short_description: "توضیح کوتاه سایت",
    footer_text: "متن توضیح فوتر",
    footer_certificates: "کد نماد‌های فوتر",
    map_script: "کد نقشه صفحه تماس",
    bg_image: "تصویر پس‌زمینه",
    gradientBg: "پس‌زمینه گردینت",
    solidBg: "پس‌زمینه رنگ ساده",
    imageBg: "پس‌زمینه با تصویر",
    gradientBgFirstColor: "رنگ اول گردینت",
    gradientBgSecondColor: "رنگ دوم گردینت",
    bg_type: "نوع تصویر پس زمینه",
    slideShowImages: "المان‌های تصویری",
    SlideShowContent: "محتوای اسلایدشو",
    nextStep: "بخش بعدی",
    mainImageSlide: "تصویر اصلی اسلاید",
    chooseColor: "انتخاب رنگ",
    chooseFormat: "انتخاب فرمت",
    chooseOwnerFile: "انتخاب منتشر کننده",
    verify_product: "تایید محصول",
    factorConfirmedToPurchase: "وضعیت سفارش ثبت شد!",
    templateUpdated: "قالب سایت آپدیت شد!",
    reject_product: "رد محصول",
    manageTemplate: "مدیریت قالب",
    exportUsersList: "دانلود لیست کاربران",
    exportProductsList: "دانلود لیست کتاب‌ها",
    weightChoosingFailed: "بازه وزنی ایراد دارد!",
    welcomeToAgentPanel: "به پنل نمایندگی خوش آمدید!",
    agentTerms: "قوانین و مقررات پنل نمایندگی",
    globalNeedVerification: "تایید سفارشات قبل از پرداخت",
    noGlobalNeedVerification: "سفارشات قبل از پرداخت نیاز به تایید ندارند!",
    noContent: "نوشته‌ای یافت نشد!",
    yesGlobalNeedVerification: "همه سفارشات قبل از پرداخت نیاز به تایید دارند!",
    pleaseConfirmAgentTerms: "لطفا قوانین و مقررات مربوط به نمایندگان را مطالعه نموده و تیک تایید را بزنید.",
    changeXPrice: "تغییر عدد x",
    changeProvinceAndCity: "تغییر استان و شهر",
    unread: "در انتظار بررسی",
    need_verification: "در انتظار تایید اولیه",
    need_verification_hint: "نیاز به تایید قبل از سفارش",
    need_verification_hint_description: "امکان سفارش این کتاب را رد و یا تایید نمایید.",
    rejectVerificationStatus: "رد امکان سفارش کتاب",
    confirmVerificationStatus: "تایید امکان سفارش کتاب",
    chooseVerificationStatus: "آیا امکان سفارش این کتاب وجود دارد؟",
    need_verification_description: "آیا این کتاب، قبل از انجام سفارش، نیاز به بررسی و تایید شما دارد؟",
    need_verification_description_user: "این کتاب قبل از انجام سفارش نیاز به بررسی و تایید فروشنده دارد!",
    all_products: "همه محصولات",
    confirmed_products: "محصولات تایید شده",
    unconfirmed_products: "در انتظار تایید",
    all_pricings: "مشاهده همه",
    confirmed_pricings: "قیمت‌گذاری تایید شده",
    unconfirmed_pricings: "در انتظار تایید",
    equalsTo: "معادل",
    gram: "گرم",
    kilogram: "کیلوگرم",
    weightHelper: "جهت محاسبه هزینه ارسال",
    inventoryHelperText: "در صورت خالی بودن، موجودی 0 درنظر گرفته می‌شود!",
    min_weight: "حداقل وزن",
    max_weight: "حداکثر وزن",
    your_commissions: "لیست کمیسیون‌ها",
    agent_cities: "شهر‌های نماینده",
    sell_agent: "نماینده فروش",
    buy_agent: "نماینده خرید",
    weight: "وزن",
    agent_panel: "پنل نمایندگی",
    agent_panel_desc: "به پنل نمایندگان وب سایت خوش آمدید!",
    yourCities: "شهر‌های تحت نمایندگی شما",
    agent_commission: "کارمزد نماینده",
    viewAll: "مشاهده همه",
    your_related_orders: "سفارش‌های شهر شما",
    addCity: "افزودن شهر",
    agentOrdersTable: "لیست سفارشات نماینده",
    noCityFound: "شهر‌ی یافت نشد!",
    subLine: "جهت بهره‌مندی از ویژگی‌های سایت وارد شوید!",
    viewInvoice: "مشاهده فاکتور",
    viewSellerInvoice: "مشاهده فاکتور فروشنده",
    submitReturnMoney: "ثبت بازگشت مبلغ",
    productWShop: "محصول مربوطه",
    agentsManagement: "مدیریت نمایندگان",
    referrer_code: "کد ",
    sell_commission: "٪ کارمزد فروش ",
    sell_commission_amount: "کارمزد فروش ",
    buy_commission: "٪ کارمزد خرید ",
    buy_commission_amount: "کارمزد خرید ",
    ManageAgent: "مدیریت نماینده",
    Submit: "ثبت",
    report: "گزارش",
    admin_note: "یادداشت ادمین",
    priority: "اولویت",
    low: "کم",
    medium: "متوسط",
    high: "زیاد",
    subject: "موضوع",
    message: "پیام",
    submitReturnMoneyFor: "ثبت بازگشت تراکنش برای فاکتور شماره",
    TransactionRecordSaved: "تراکنش ثبت شد",
    TransactionRecordSavedError: "مشکلی در ثبت تراکنش وجود دارد!",
    bestSellingProducts: "برترین کتاب‌ها",
    youHaveNoAddress: "هیچ آدرسی ندارید",
    checkProducts: "محصولات مختلف را بررسی کنید",
    firstAddAnAddress: "ابتدا یک آدرس اصافه کنید",
    allOrders: "همه سفارش‌ها",
    addYourAddress: "آدرس خود را وارد کنید!",
    viewDetails: "مشاهده",
    viewTicket: "مشاهده تیکت",
    viewTickets: "مشاهده تیکت‌ها",
    systemSupportRequest: "درخواست پشتیبانی سیستم",
    productSupportRequest: "درخواست پشتیبانی محصول",
    home: "خانه",
    manageViolations: "مشاهده گزارش‌های تخلف",
    supplier: "فروشنده",
    old_url: "URL قدیمی",
    new_url: "URL جدید",
    related_admin: "ادمین مربوطه",
    department: "دپارتمان",
    departments: "دپارتمان‌ها",
    editRedirect:"ریدایرکت ویرایش شد.",
    editRedirectFailed:"ویرایش ریدایرکت با مشکل رو به رو شد.",
    deleteRedirect:"ریدایرکت حذف شد.",
    deleteRedirectFailed:"حذف ریدایرکت با مشکل رو به رو شد.",
    deleteSelectedRedirects:"حذف ریدایرکت‌های انتخاب شده با مشکل رو به رو شد.",
    addRedirectFailed:"ایجاد ریدایرکت با مشکل رو به رو شد.",
    addRedirect:"ریدایرکت ایجاد شد.",
    redirects : "ریدایرکت‌ها",
    manageRedirects : "مدیریت ریدایرکت‌ها",
    manageTransferPricing : "مدیریت هزینه ارسال",
    transferPricing : "مدیریت هزینه ارسال",
    viewTransferPricing : "جدول هزینه ارسال",
    finished_inventory: "کتاب‌های ناموجود",
    finishing_inventory: "کتاب‌های رو به اتمام ",
    manageBookStore: "مدیریت کتاب فروشی ",
    pending_orders: "سفارشات در انتظار تایید",
    ready_orders: "سفارشات درحال آماده سازی",
    done_orders: "سفارشات ارسال شده  ",
    rejected_orders: "سفارشات لغو شده  ",
    total_products: "تعداد کل کتاب‌ها ",
    total_pending_products: "کتاب‌های درحال بررسی ",
    total_rejected_products: "کتاب‌های تایید نشده ",
    manageInventory: "مدیریت موجودی",
    addNewProduct: "کتاب تازه ایجاد کنید",
    shopIsPending: "در انتظار بررسی!",
    firstCreateShop: "ابتدا فروشگاه بسازید",
    sellerGuidLine: "راهنمای مسیر",
    sellerGuidLineDescription: "گام به گام پیش بروید و با ساخت یک فروشگاه حرفه‌ای، کتاب‌های خود را به مشتریان بیشتری ارائه دهید!",
    userGuidLineDescription: "گام به گام پیش بروید و اطلاعات خود را تکمیل کنید تا ساده تر محصولات مورد نظر خود را بیابید!",
    marketerGuidLineDescription: "فروشگاه‌های کتاب را به عضویت در پنجره تشویق کنید، پس از ثبت نام آن‌ها در پنجره و درج کد شما به عنوان بازاریاب از فروش آن ها پورسانت دریافت کنید. ",
    OrdersChart: "نمودار سفارش‌ها",
    ordersAnalytics: "گزارش سفارشات",
    doneOrders: "سفارش‌های ارسال شده",
    payedToShopOrders: "سفارش‌های تسویه شده",
    confirmedOrders: "سفارش‌های در انتظار تایید",
    rejectedOrders: "سفارش‌های لغو شده",
    sendingOrders: "سفارش‌های درحال آماده سازی",
    totalSells: "جمع فروش‌ها",
    thisWeek: "هفته اخیر",
    thisMonth: "ماه اخیر",
    thisYear: "سال اخیر",
    thanks: "با تشکر",
    completeYorDetails: "تکمیل اطلاعات شخصی",
    doCompleteDetails: "اطلاعات خود را تکمیل کنید!",
    inCheckingDetails: "اطلاعات درحال بررسی می‌باشند!",
    compeltedDetails: "حساب کاربری تایید شده!",
    completeYorDetailsDesc: "لطفا اطلاعات شخصی حود را تکمیل نمایید!",
    shopsSells: "حجم فروش فروشندگان",
    totalCommissions: "جمع کارمزد‌ها",
    todayCommission: "کارمزد‌ امروز",
    book_confirmation_requests: "درخواست تایید کتاب",
    rejected_products: "کتب تایید نشده",
    shop_confirmation_requests: "درخواست تایید فروشگاه",
    verification_details_confirmation_requests: "درخواست تایید حساب بانکی",
    reviews_confirmation_requests: "درخواست تایید دیدگاه",
    contacts: "فرم تماس با ما",
    pendingMarketer: "بازاریاب در انتظار تایید",
    wallet_confirmation_requests: "درخواست واریز وجه",
    buyCommissions: "جمع کارمزد‌های خرید",
    payedOrders: "سفارش‌های تسویه شده",
    sellCommissions: "جمع کارمزد‌های فروش",
    viewOtherSellers: "مشاهده سایر فروشندگان",
    deleteProductFromCart: "حذف محصول از سبد خرید",
    firstConfirmUser: "ابتدا اکانت کاربر را تایید کنید!",
    firstConfirmShop: "ابتدا فروشگاه این کاربر را تایید کنید!",
    doYouWantToHideProducts: "آیا می‌خواهید محصولات این دسته را از دید کاربران غیر عضو پنهان کنید؟",
    discountsAttention: "توجه! مبلغ کد تخفیف در صورتی که فروشگاه انتخاب نشده باشد، از کارمزد سایت کسر می‌شود.",
    suppliers: "فروشندگان",
    belowProductsHasAddressError: "محصولات زیر امکان ارسال به آدرس انتخابی شما را ندارند!",
    youHavePendingWithdrawRequest: "شما یک درخواست در انتظار بررسی دارید!",
    cantWithdrawSmallerThan100000: "امکان برداشت کمتر از ۱۰۰ هزار تومان وجود ندارد!",
    cantWithdrawSmallerThan100: "امکان برداشت کمتر از ۱۰۰ تومان وجود ندارد!",
    cantWithdrawSmallerThan50000: "امکان برداشت کمتر از ۵۰ هزار تومان وجود ندارد!",
    fillYourDetailsFirstDescription: "لطفا ابتدا اطلاعات حساب کاربری خود را تکمیل کنید",
    fillYourDetailsFirst: "تکمیل حساب کاربری",
    yourAccountInfoIsPending: "در انتظار بررسی",
    yourAccountInfoIsPendingDesc: "حساب کاربری شما در دست بررسی است! پس از تایید می‌توانید سفارش خود را ثبت کنید.",
    deleteIt: "پاک شود",
    backToPrevPage: "مرحله قبل",
    payToShop: "تسویه با فروشنده",
    payed_to_shop: "تسویه شده",
    purchaseDone: "پرداخت انجام شد!",
    purchaseRejected: "در انجام پرداخت مشکلی پیش آمد!",
    payToShopAreYouSure: "آیا قصد تسویه این سفارش را دارید؟ ",
    changeFactorStatus: "تغییر وضعیت فاکتور",
    changeStatus: "تغییر وضعیت سفارش",
    receivingConfirmation: "تغییر وضعیت",
    receivingConfirmationShop: "تایید سفارش",
    isOrderReceivedToYou: "محصولات فروشنده آماده ارسال به خریدار است؟",
    rejectOrderShop: "لغو سفارش",
    rejectOrderShopQ: "آیا از لغو سفارش اطمینان دارید؟",
    isOrderReceivedToYouShop: "آیا محصولات آماده ارسال به خریدار است؟",
    changeStatusHelper: "با احتیاط و در صورت اطمینان تغییر دهید!",
    edit: "ویرایش",
    editShippingCode: "ویرایش کد رهگیری پستی",
    view: "مشاهده",
    payableMoney: "مبلغ قابل پرداخت",
    no_discount: "کد تخفیف وارد شده معتبر نیست!",
    editBanner: "ویرایش بنر",
    editCard: "ویرایش کارت",
    pleaseChooseYourAddress: "لطفا آدرس تحویل خود را انتخاب کنید!",
    PleaseChooseAnAddressToContinue: "لطفا آدرس تحویل خود را انتخاب کنید!",
    assignedToYou: "برای شما اعمال شد.",
    save: "ذخیره",
    saveAndPublish: "ذخیره و انتشار",
    saveAndNewProduct: "ذخیره و افزودن محصول جدید",
    cancelLong: "انصراف و بازگشت به لیست محصولات",
    makeOrder: "ثبت نهایی سفارش",
    makeSimpleOrder: "ثبت سفارش",
    makeSimpleOrderDesc: "محصولات مورد نظر خود را سفارش دهید!",
    commission: "کارمزد",
    commissionMarketer: "پورسانت",
    site_commission: "کارمزد وب‌سایت",
    total_commission: "کل کارمزد",
    number: "عدد",
    icon: "آیکون",
    link: "لینک ",
    app_link: "لینک اپلیکیشن",
    app_link_help: "در صورتی که لینک به صفحه محصول باشد نیاز به تکمیل این فیلد نیست.",
    checkout: "تکمیل سفارش",
    productsInCart: "محصولات موجود در سبد خرید",
    discount_onlyForThisCategory: "کد تخفیف فقط برای دسته‌بندی ",
    discount_onlyForThisShop: "کد تخفیف فقط برای فروشگاه ",
    discount_end_sentence: "لحاظ می‌شود.",
    isShopGlobal: "آیا فروشگاه سراسری است؟",
    iconsList: "لیست آیکون‌ها",
    bg_color: "رنگ پس‌زمینه",
    addSlideShow: "افزودن اسلایدشو",
    addBanner: "افزودن بنر",
    addCard: "افزودن کارت",
    primary_button_text:'متن دکمه اصلی',
    primary_button_icon:'آیکون دکمه اصلی',
    primary_button_link:"لینک دکمه اصلی",
    secondary_button_text:'متن دکمه دوم',
    secondary_button_icon:'آیکون دکمه دوم',
    secondary_button_link:"لینک دکمه دوم",
    featuredProduct: "محصول ویژه؟",
    managementSetting: "تنظیمات مدیریتی",
    shopTotalRating: "امتیاز کلی فروشگاه",
    productTotalRating: "امتیاز کلی محصول",
    productTotalRatingDesc: "این امتیاز به صورت اتوماتیک از میانگین امتیاز کاربران به دست می‌آید.",
    wishlist: "لیست علاقه‌مندی‌‌ها",
    noWishlist: "محصولی در لیست علاقه‌مند‌ی‌ها نیست!",
    changeCategories: "تغییر دسته‌بندی‌ها",
    chooseCategoryIcon: "آیکون دسته‌بندی",
    siteSettings: "تنظیمات سایت",
    manageGlobalCommission: "کارمزد کلی",
    servicesPrice: "هزینه خدمات",
    hidePrices: "مخفی سازی قیمت از کاربران غیر عضو",
    pricesAreShown: "نمایش قیمت‌ها",
    pricesAreHidden: "مخفی سازی قیمت‌ها",
    youAreInSomeOneAccount: "شما در حساب کاربری فرد دیگری هستید!",
    backToMyAccount: "بازگشت",
    loginToUserAccount: "ورود به اکانت این کاربر",
    userShouldConfirmMobileFirst: "ابتدا باید شماره موبایل کاربر تایید شود!",
    marketerIdCopied: "کد یونیک بازاریاب کپی شد",
    requestToDeleteProduct: "درخواست حذف کتاب",
    removeProduct: "حذف کتاب",
    requestedToDelete: "درخواست حذف کتاب ارسال شد!",
    pricingThumbnailDesc: "اگر می‌خواهید تصویر خودتان بجای تصویر کتاب نمایش داده شود آن را آپلود کنید!",
    backToLogin: "بازگشت به صفحه ورود",
    doLogin: "وارد شوید!",
    nonOfThem: "هیچکدام",
    uploadedDate: "زمان آپلود",
    editMobile: "تغییر شماره موبایل",
    editMobileDesc: "در صورتی که قصد تغییر شماره موبایل خود (",
    editMobileDesc2: ") را دارید، آن را وارد کنید.",
    pricing: "قیمت‌گذاری کتاب‌ها",
    pricingOnly: "قیمت‌گذاری",
    doPricing: "برای محصولات خود و دیگران قیمت گذاری کنید!",
    pricingFor: "قیمت‌گذاری برای",
    pricingProduct: "قیمت‌گذاری",
    changeRole: "تغییر سطح دسترسی",
    changeRoleToProvider: "آیا می‌خواهید سطح دسترسی خود را تغییر دهید؟",
    editAddress: "ویرایش آدرس",
    customHeadDescription: "در این قسمت می‌توانید کد‌های مورد نیاز خود مانند انواع تگ meta و Open Graph را به تگ <head> سایت  اضافه کنید. ",
    customBodyDescription: "در این قسمت می‌توانید کد‌های مورد نیاز خود مانند انواع کد Java Script و... را به انتهای تگ <body> سایت  اضافه کنید. ",
    shopOwner: "مالک فروشگاه",
    myShops: "فروشگاه‌های من",
    shopsList: "لیست فروشگاه‌ها",
    myShop: "فروشگاه من",
    makeYourShop: "فروشگاه خود را بسازید!",
    addresses: "آدرس‌های من",
    addAdressDetailsLong: "آدرس‌های خود را در این بخش اضافه کنید و در انتخاب محل تحویل سفارش‌های خود از آن استفاده کنید.",
    addAddressDetails: "آدرس‌های خود را اضافه کنید!",
    addAddress: "افزودن آدرس",
    addAddressDescription: "آدرس‌های خود را در این بخش مدیریت کنید!",
    moreInfo: "اطلاعات بیشتر",
    beSupplier: "فروشنده شوید!",
    viewShop: "مشاهده فروشگاه",
    viewShops: "مشاهده فروشگاه‌ها",
    relatedShop: "فروشگاه مربوطه",
    shopName: "نام فروشگاه",
    shop: "فروشگاه",
    menu_title: "نام آیتم",
    url: "آدرس اینترنتی",
    numberOfSells: "تعداد فروش",
    buyer: "خریدار",
    makeAShopFirst: "ابتدا فروشگاه خود را بسازید!",
    makeAShopFirstDescription: "لطفا قبل از ایجاد کتاب فروشگاه خود را بسازید!",
    chooseShop: "انتخاب فروشگاه",
    shopDiscountHelp: "اگر می‌خواهید کد تخفیف فقط برای یک فروشگاه اعمال شود.",
    categoryDiscountHelp: "اگر می‌خواهید کد تخفیف فقط برای یک دسته بندی اعمال شود.",
    chooseShopHelperText: "فروشگاه ارائه دهنده محصول",

    productInsertionDescription: "شما می توانید محصول خود را در این بخش بسازید و یا اطلاعات آن را از  پست اینستاگرام خود درج کنید ",
    welcomeToSite: "به مارکت اینجازنونس خوش آمدید!",
    bio: "توضیح کوتاه",
    contact_name: "نام و نام خانوادگی",
    fullName: "نام و نام خانوادگی",
    company_name: "نام شرکت",
    contact_mobile: "شماره موبایل",
    contact_melli_code: "کد ملی",
    bioDescription: "مختصری در ارتباط با فروشگاه",
    contactInfo: "اطلاعات رابط",
    shopDescription: "معرفی فروشگاه",
    description: "توضیح کوتاه",
    related_description: "توضیحات مربوطه",
    manageShops: "مدیریت فروشگاه‌ها",
    manageShop: "مدیریت فروشگاه‌",
    management: "مدیریت",
    makeShop: "درخواست ایجاد فروشگاه جدید",
    editShop: "ویرایش اطلاعات فروشگاه",
    yourShopIsActive: "تبریک! فروشگاه شما تایید شده و فعال است.",
    yourShopIsInchecking: "فروشگاه شما در دست بررسی است!",
    yourAccountIsActive: "تبریک! حساب کاربری شما تایید شده و فعال است.",
    yourAccountIsInChecking: "حساب کاربری شما در دست بررسی است!",
    yourProductIsActive: "تبریک! محصول شما تایید شده و فعال است.",
    yourProductIsRejected: "محصول تایید نشد!",
    yourShopIsRejected: "فروشگاه تایید نشد!",
    yourProductIsInchecking: "محصول شما در دست بررسی است!",
    yourPricingIsActive: "قیمت‌‌گذاری شما تایید شده و درحال نمایش به کاربران است",
    yourPricingIsInchecking: "قیمت‌‌گذاری شما در دست بررسی است!",
    welcomeShopCreatorTitle: "فروشنده گرامی خوش‌آمدید!",
    WelcomeShopCreatorText: "شما می‌توانید از این بخش فروشگاه خود را ایجاد کنید، پس از تایید فروشگاه امکان انتشار محصول برای شما فراهم خواهد شد.",
    deleteShop: "فروشگاه حذف شد.",
    deleteShopFailed: "در حذف فروشگاه مشکلی به وجود آمده است.",
    deleteProduct: "کتاب حذف شد.",
    deleteProductFailed: "در حذف کتاب مشکلی به وجود آمده است.",
    deleteReview: "دیدگاه حذف شد.",
    deleteReviewFailed: "در حذف دیدگاه مشکلی به وجود آمده است.",
    leaderboard: "جدول امتیازات",
    searchPlaceholder:'جستجوی متخصص‌ها...',
    resume: "ادامه",
    info: "اطلاعات پایه",
    portfo: "نمونه کارها",
    services: "خدمت‌ها",
    projects: "پروژه‌ها",
    pendingProjects: "پروژه‌های در انتظار تایید",
    doneProjects: "پروژه‌های انچام شده",
    teaching: "تدریس خصوصی",
    courses: "لیست دوس تدریسی",
    jobrequest: "استخدام",
    teamUp: "تیم سازی",
    consultation: "مشاوره",
    moneyManagement: "مدیریت مالی",
    studentsList: "لیست شاگردان",
    contents: "نوشته‌ها",
    manageContents: "مدیریت نوشته‌ها",
    addContent: "ایجاد نوشته جدید",
    viewContent: "مشاهده نوشته",
    makeContent: "انتشار نوشته",
    editContent: "ویرایش نوشته",
    contentTitle: "تیتر مقاله",
    pageTitle: "تیتر صفحه",
    addPage: "افزودن صفحه",
    contentAdded: "نوشته‌ی شما ایجاد شد.",
    contentAddingFailed: "در ایجاد نوشته مشکلی به وجود آمده است.",
    contentEdited: "نوشته‌ی شما ویرایش شد.",
    contentEditingFailed: "در ویرایش نوشته مشکلی به وجود آمده است.",
    productAdded: "کتاب شما ایجاد شد.",
    productAddingFailed: "در ایجاد کتاب مشکلی به وجود آمده است.",
    productEdited: "کتاب شما ویرایش شد.",
    productEditingFailed: "در ویرایش کتاب مشکلی به وجود آمده است.",
    deleteContent: "نوشته‌ حذف شد.",
    deleteContentFailed: "در حذف نوشته مشکلی به وجود آمده است.",
    wholesalePriceShouldBeLess: "قیمت فروش عمده باید کمتر از قیمت عادی باشد.",
    howToSell: "نحوه فروش",
    sellOnline: "آنلاین",
    sellOffline: "آفلاین",
    myPoints: "امتیازات من",
    ifYouWantSellOnline: "در صورتی که قصد فروش آنلاین دارید، ابتدا اطلاعات حساب بانکی خود را تکمیل کنید!",
    province: "استان",
    city: "شهر",
    editPage: "ویرایش صفحه",
    makePage: "ایجاد صفحه",

    /*********Global**********/
    account: "حساب کاربری",
    manageProducts: "مدیریت محصولات",
    headLineMakeYourFirstProduct: "محصولات خود را ایجاد کنید، محتوای آن‌ها را بهبود دهید و از ویژگی‌های های مارکت اینجازنونس لذت ببرید!",
    productDetails: "اطلاعات کتاب",
    myProducts: "کتاب‌های من",
    editProduct: "ویرایش کتاب",
    makeProduct: "ایجاد محصول جدید",
    purchaseProduct: "سفارش کتاب",
    resumeOrder: "ادامه سفارش",
    productName: "نام کتاب",
    productEnglishName: "نام انگلیسی محصول",
    productDescription: "توضیحات",
    product: "کتاب",
    viewProduct: "مشاهده کتاب",
    viewOrders: "مشاهده سفارش‌ها",
    viewOrdersDetails: "همه سفارش‌های گذشته خود را از این بخش مشاهده نمایید!",
    viewOrder: "مشاهده سفارش‌",
    created_at_factor: "تاریخ ثبت سفارش",
    user_delivery: "تحویل گیرنده",
    mobileNumber: "شماره موبایل",
    orderDetails: "جزئیات سفارش‌",
    viewUserDetails: "اطلاعات کاربر",
    manageOrders: "مدیریت سفارش‌ها",
    manageOrder: "مدیریت سفارش‌",
    manageDiscounts: "مدیریت کدهای تخفیف",
    discounts: "تخفیف‌ها",
    discount_code: "کد تخفیف",
    input_your_discount_code: "در صورتی که کد تخفیف دارید، آن را وارد کنید!",
    discount_type: "نوع تخفیف",
    discount_value: "میزان تخفیف",
    commissionFestival: "کارمزد در چشنواره",
    percent: "درصد",
    fixed: "مقدار ثابت",
    discount_total_count: "تعداد قابل استفاده",
    total_price_to_get: "مبلغ تسویه",
    discount_count: "تعداد استفاده شده",
    discount_expired_at: "تاریخ انقضا",
    makeDiscount: "ایجاد کد تخفیف",
    editDiscount: "ویرایش کد تخفیف",
    shopOrders: "لیست فروش‌ها",
    viewShopOrders: "مشاهده فروش‌ها",
    products: "کتاب‌ها",
    productsList: "لیست کتاب‌ها",
    productOwner: "مالک محصول",
    manageComments: "مدیریت کامنت‌ها",
    manageShopComments: "مدیریت کامنت‌ فروشگاه‌ها",
    comments: "کامنت‌ها",
    commentForReplayDescription : "اگر قصد پاسخ به کامنتی را دارید از اینجا انتخاب کنید",
    noProduct:"محصولی وجود ندارد",
    chooseProductForComment : "انتخاب محصول",
    chooseShopForComment : "انتخاب فروشگاه",
    chooseContentForComment : "انتخاب نوشته",
    commentEdited:"کامنت ویرایش شد",
    commentAdded:"کامنت ایجاد شد",
    commentAddingFailed:"افزودن کامنت با مشکل مواجه شد.",
    commentEditingFailed:"ویرایش کامنت با مشکل مواجه شد.",
    commentRemoved: "کامنت با موفقیت حذف شد",
    dataRemoved: "اطلاعات با موفقیت حذف شد",
    dataRemovingFailed: "حذف اطلاعات با مشکل رو به رو شد.",
    commentRemovingFailed: "حذف کامنت با مشکل رو به رو شد.",
    deleteSelectedComments: "کامنت‌های انتخاب شده حذف شدند.",
    deleteSelectedUsers: "کاربران انتخاب شده حذف شدند.",
    role: "سطح دسترسی",
    allRoles: "تمام سطوح دسترسی",
    allUserTypes: "تمام انواع کاربران",
    editComment: "ویرایش کامنت",
    addComment: "افزودن کامنت",
    parentCommentDesc : "شما درحال پاسخ دادن به کامنت زیر هستید:",
    productRating:"امتیاز محصول",
    shopRating:"امتیاز فروشگاه",
    contentRating:"امتیاز نوشته",
    inserProduct:"درج محصول",
    inserProductFromInstagram:"درج محصول از اینستاگرام",
    confirmStatus:"وضعیت تایید",
    removeComment: "حذف کامنت",
    translateFront: "ترجمه فرانت",
    manageSlideShows: "مدیریت اسلایدشو‌",
    manageBanners: "مدیریت بنر‌ها",
    editSlideShow: "ویرایش اسلایدشو‌",
    translateFrontDesc: "در صورتی که تغییرات را با زدن دکمه ثبت اطلاعات انجام داده‌اید و تغییرات در این قسمت مشاهده نشد، از قسمت فرانت بررسی نمایید.",

    thankYou: "با تشکر!",
    settings: "تنظیمات",
    exit: "خروج از سایت",
    myAccount: "حساب کاربری",
    myInfo: "اطلاعات من",
    makeDraft: "ذخیره پیش‌نویس",
    userPanel: "پنل کاربری",
    draft: "پیش‌نویس",
    published: "منتشر شده",
    someFieldsHasError: "یک یا چند فیلد دارای خطا هستند، لطفا بررسی کنید",
    search: "جستجو",
    author: "نویسنده",
    creator: "مالک محصول",
    choose: "انتخاب",
    updateTime: "بروزرسانی",
    created_at: "تاریخ ایجاد",
    updated_at: "تاریخ بروزرسانی",
    makeBrand: "ایجاد ناشر",
    editBrand: "ویرایش ناشر",
    filters: "فیلتر‌ها",
    sliderTitle: "تیتر",
    bannerTitle: "تیتر بنر",
    videoLink: "لینک ویدیو",
    subtitleBanner: "متن کناری بنر",
    bannerPosition: "محل قرارگیری",
    activityStatus: "وضعیت",
    thumbnail: "تصویر",
    list_image: "تصویر لیست",
    epThumbnail: "تصویر اپیزود",
    chapterThumbnail: "تصویر فصل",
    epDescription: "توضیحات اپیزود",
    chapterDescription: "توضیحات فصل",
    epAudioFile: "فایل صوتی اپیزود",
    epubFile: "فایل کتاب این فصل",
    epubFileDL: "دانلود فایل کتاب",
    rawFileDL: "دانلود فایل خام",
    chapterName: "نام فصل",
    epAudioFileSample: "نمونه فایل صوتی",
    publishStatus: "وضعیت انتشار",
    publishStatusDesc: "در این قسمت می‌توانید وضعیت انتشار کتاب خود را تغییر دهید. (در صورت کلیک بر روی دکمه اعمال و نیازی به دکمه ذخیره نمی‌باشد) ",
    keywordsLabel: "عبارات کلیدی",
    allKeywordsAreTyped: "امکان افزودن کلمات کلیدی بیشتر ندارید. ",
    keywordsDescription: "تگ‌های مرتبط را بنویسید. (برای مثال، ست هدیه، سلامت فردی و...)",
    seoDescription: "توضیح کوتاه",
    linkPlaceholder:"یک آدرس اینترنتی وارد کنید",
    addImage: "افزودن تصویر",
    addFile: "افزودن فایل",
    imageName: "نام فایل",
    ownerMedia:"ناشر",
    insertMedia:"درج فایل",
    insert:"درج",
    linkCopied:"لینک کپی شد.",
    uploadSuccess: "آپلود با موفقیت انجام شد",
    editFile:"فایل با موفقیت ویرایش شد",
    editFileFailed:"ویرایش فایل با مشکل رو به رو شد.",
    tableAdded:"جدول ایجاد شد",
    tableAddingFailed:"افزودن جدول با مشکل مواجه شد.",
    deleteTable:"جدول با موفقیت حذف شد",
    deleteTableFailed:"حذف جدول با مشکل رو به رو شد.",
    tableEdited:"جدول ویرایش شد.",
    tableEditingFailed:"ویرایش جدول با مشکل مواجه شد.",
    selfFiles: "فایل‌های من",
    adminsFiles: "فایل‌های مدیران سایت",
    everyBodyFiles: "فایل‌های همه",
    uploading: "درحال آپلود...",
    uploadDone: "فایل آپلود شد.",
    allTypes: "همه فرمت‌ها",
    image: "تصویر",
    video: "ویدیو",
    document: "سند",
    audio: "صوت",
    chooseVideo:"انتخاب ویدیو",
    multiImport:"انتخاب رسانه‌ها",
    filesTable: "فایل‌های ذخیره شده",
    fileManager: "رسانه‌ها",
    lastUpdate: "آخرین بروزرسانی",
    userDetail: "اطلاعات کاربر",
    usersManagement: "مدیریت کاربران",
    allUsers: "مشاهده کاربران",
    marketersList: "مشاهده بازاریابان",
    marketerInfos: "تنظیمات بازاریابی",
    usersActivity: "فعالیت‌ کاربران",
    paymentManagement: "اطلاعات مالی کاربران",
    addUser: "افزودن کاربر",
    editUser: "ویرایش کاربر",
    editDetails: "ویرایش پروفایل",
    logoSize600: "سایز مناسب 600x600px می‌باشد.",
    logo: "لوگو فروشگاه",
    logo_brand: "لوگو",
    cover: "کاور فروشگاه",
    chooseMedia: "انتخاب رسانه",
    submitErrorFile:"فایل ارسالی مشکل دارد.",
    imageSizeWidth700: "عرض مناسب تصویر 700px می‌باشد.",
    thumbnailSize: " حداقل عرض مناسب تصویر 600px می‌باشد.",
    userAvatarSet:"تصویر پروفایل شما بروز شد.",
    profileImage: "تصویر پروفایل",
    userAvatarSetFailed:"در تغییر تصویر پروفایل مشکلی به وجود آمده است.",
    loadingThumbnailFailed: "در بارگذاری تصویر مشکلی پیش آمده",
    ChooseImageLink:" برای کپی لینک، سایز مورد نظر را انتخاب کنید.",
    deleteFile:"فایل با موفقیت حذف شد",
    deleteFileFailed:"حذف فایل با مشکل رو به رو شد.",
    deleteSelectedFiles:"فایل ها با موفقیت حذف شدند",
    alt: "متن جایگزین (alt)",
    chooseImage: "انتخاب تصویر",
    emptyImage: "تصویری انتخاب کنید!",
    descriptionPlaceHolder: "توضیحات مربوطه را بنویسید",
    words:"کلمه",
    characters:"کاراکتر",
    uploadImage: "آپلود رسانه",
    ThumbnailTitle: "تصویر شاخص",
    back_cover: "تصویر پشت جلد",
    front_cover: "تصویر اصلی (روی جلد)",
    inside_pdf: "فایل PDF تعدادی از صفحات کتاب",
    attached_file: "فایل پیوست",
    loading: "درحال بارگذاری...",
    login: "ورود",
    homePage: "صفحه اصلی",
    contactPage: "تماس با ما",
    shopPage: "همه محصولات",
    rulesPage: "قوانین استفاده",
    aboutPage: "درباره ما‌",
    shops: "فروشگاه‌ها",
    orLoginWith: "ورود با",
    backToHomePage: "بازگشت به صفحه اصلی",
    emailOrMobile: "ایمیل یا موبایل",
    first_name: "نام",
    last_name: "نام‌خانوادگی",
    username: "نام کاربری",
    userName: "نام و نام‌خانوادگی",
    phone: "تلفن ثابت",
    melli_code_compnay: "شناسه ملی",
    financial_code: "شماره اقتصادی",
    register_number: "شماره ثبت",
    mobile: "موبایل",
    mobileSample: "مثل 09123456789",
    email: "ایمیل",
    sms: "پیام کوتاه",
    send_sms: "ارسال پیام کوتاه اعلان تیکت",
    verifyEmail: "تایید ایمیل",
    password: "رمزعبور",
    comment: "کامنت",
    passwordConfirm: "تکرار رمزعبور",
    passwordStrength:"حداقل ۶ کاراکتر، شامل عدد و حروف",
    passwordChanged:"رمزعبور با موفقیت تغییر کرد.",
    currentPasswordError:"رمزعبور فعلی صحیح نیست.",
    currentPassword:"رمزعبور فعلی",
    register: "ثبت‌نام",
    doRegister: "ثبت‌نام کنید",
    dontHaveAccount: "حساب کاربری ندارید؟",
    haveAccount: "حساب کاربری دارید؟",
    loginError:"ایمیل یا رمزعبور اشتباه است.",
    forgetPass:"فراموشی رمز عبور",
    loginWithToken:"ورود با رمز یکبار مصرف",
    dashboard:"داشبورد",
    emptyUsername: "نام کاربری خود را وارد کنید.",
    emptyTableCells: "جدول خالی است.",
    wrongUsername: "نام کاربری فقط میتواند شامل حروف و اعداد انگلیسی باشد.",
    NotFreeUsername: "این نام کاربری قبلا انتخاب شده.",
    existEmail: "این ایمیل قبلا ثبت شده.",
    existMobile: "این شماره موبایل قبلا ثبت شده.",
    emptyEmail: "ایمیل خود را وارد کنید.",
    emptyMobile: "شماره موبایل خود را وارد کنید.",
    wrongEmail: "فرمت ایمیل اشتباه است.",
    wrongMobile: "فرمت شماره موبایل اشتباه است.",
    wrongPrice: "مبلغ اشتباه است",
    transferPrice: "هزینه ارسال",
    transfer_type: "نحوه ارسال",
    wrongSheba: "شماره شبا اشتباه است. (۲۴ عدد)",
    wrongCreditNumber: "شماره کارت اشتباه است. (۱۶ عدد)",
    emptyPassword: "رمز عبور را وارد کنید.",
    weakPassword: "رمز عبور ضعیف است.",
    notEqualPassword: "رمز عبور و تکرار آن یکسان نیست.",
    lessPost: "نوشته‌ی پست کم است",
    maxLength: "نوشته طولانی است",
    SelectFromSelect:"انتخاب کنید",
    emptyField:'فیلد خالی است.',
    wrongPostalCode:'کد پستی باید ۱۰ رقم باشد',
    fileIsEmpty:'انتخاب فایل ضروری است!',
    fillPrevFieldFirst:'ابتدا فیلد قبل را پر کنید.',
    emptyName: "نام ضروری است",
    emptyLastName: "نام خانوادگی ضروری است",
    noMatchPassword: "تاییده با رمز عبور یکسان نیست",
    emptyTagName:"نام برچسب ضروری است",
    emptyBrandName:"نام ناشر ضروری است",
    cantBeMoreThan100:'نمی‌تواند بیشتر از 100 باشد',
    maxLength60:"طول این فیلد نباید بیش از ۶۰ کاراکتر باشد.",
    maxLength600:"طول این فیلد نباید بیش از ۶۰۰ کاراکتر باشد.",
    maxLength70:"طول این فیلد نباید بیش از ۷۰ کاراکتر باشد.",
    maxLength150:"طول این فیلد نباید بیش از ۱۵۰ کاراکتر باشد.",
    maxLength50:"طول این فیلد نباید بیش از ۵۰ کاراکتر باشد.",
    maxLength255:"طول این فیلد نباید بیش از ۲۵۵ کاراکتر باشد.",
    maxLength500:"طول این فیلد نباید بیش از ۵۰۰ کاراکتر باشد.",
    wrongMelliCode: "کد ملی اشتباه است.",
    maxLength1000:"طول این فیلد نباید بیش از ۱۰۰۰ کاراکتر باشد.",
    maxLength4000:"طول این فیلد نباید بیش از ۴۰۰۰ کاراکتر باشد.",
    maxLength3000:"طول این فیلد نباید بیش از ۳۰۰۰ کاراکتر باشد.",
    maxLength30:"طول این فیلد نباید بیش از 30 کاراکتر باشد.",
    between0to100:"درصد باید در بازه ۰ تا ۱۰۰ باشد",
    pleaseCheckTheBox:"لطفا قوانین را تایید کنید",
    emptyEmailOrMobile:"ایمیل یا شماره موبایل خود را وارد کنید.",
    dear:"عزیز",
    errorHappens:"در بارگذاری سایت خطایی رخ داده است!",
    allChangesSaved:"تمام تغییرات ذخیره شد.",
    allItemsSaved:"تمام موارد ذخیره شد.",
    addNewSharing:"افزودن تقسیم درآمد",
    allChangesSavingFailed:"ذخیره سازی تغییرات با مشکل مواجه شد!",
    registerSuccess: "کاربر با موفقیت ثبت شد.",
    registerError: "خطا در ایجاد کاربر",
    cantLoadData:"در بارگیری مطالب مشکلی است.",
    fileSize500kb:"حجم فایل باید کمتر از ۵۰۰kb باشد.",
    fileSize100mb:"حجم فایل باید کمتر از ۱۰۰mb باشد.",
    fileSize1mb:"حجم فایل باید کمتر از ۱mb باشد.",
    fileSize5mb:"حجم فایل باید کمتر از 5mb باشد.",
    fileSize500mb:"حجم فایل باید کمتر از 500mb باشد.",
    fileSize20mb:"حجم فایل باید کمتر از ۲۰mb باشد.",
    fileSize200mb:"حجم فایل باید کمتر از ۲۰۰mb باشد.",
    fileSizeWeak:"فایل بی کیفیت است!",
    uploadBook:"آپلود فایل کتاب",
    uploadRaw:"آپلود فایل خام",
    size:"قطع کتاب",
    sizes:"انواع قطع کتاب",
    cover_type:"نوع جلد",
    cover_types:"انواع جلد",
    number_of_pages:"تعداد صفحات",
    total_duration:"مدت زمان کلی",
    total_duration_helper:"مدت زمان را به صورت 'ثانیه:دقیقه:ساعت' وارد نمایید",
    minute:"دقیقه",
    publish_year:"سال چاپ",
    publish_turn:"نوبت چاپ",
    bookFile:"فایل کتاب",
    viewUploadedFile:"مشاهده فایل",
    storageIsFull:"فضای ذخیره سازی شما پر شده است!",
    makingTokenError:"در ایجاد کد تایید مشکلی به وجود آمده است. ",
    youLoggedOff:"شما از پنل خارج شدید",
    mobileVerified:"شماره موبایل شما تایید شد.",
    wrongToken:"کد تایید اشتباه است. ",
    mobileVerify: "تایید موبایل",
    verifyMobile: "تایید شماره موبایل",
    sendTokenText1:"رمز یکبارمصرف شما به شماره",
    sendTokenText2:"ارسال شد.",
    sendTokenTextResend:"رمز یکبار مصرف مجددا برای شما ارسال شد.",
    sendTokenText3:"زمان باقی مانده تا ارسال مجدد پیامک",
    logOut: "خروج از سایت",
    confirm: "تایید",
    token:"کد تایید",
    forgetPassword: "فراموشی رمزعبور",
    invalidMobileNumber:"این شماره در سیستم وجود ندارد",
    recoverPassword:"بازیابی رمزعبور",
    recoverPasswordText:"برای بازیابی رمز عبور، شماره موبایل خود را وارد کنید.",
    sendAgain:"ارسال دوباره",
    changePassword: "تغییر رمزعبور",
    newPassword:"رمزعبور جدید",
    newPasswordConfirm:"تکرار رمزعبور جدید",
    loginWithUserPass:"ورود با اطلاعات کاربری",
    addYourNumberFirst:"برای ورود به سایت، شماره موبایل خود را وارد کنید.",
    connectionError:'اینترنت شما قطع است.',
    copyright: " © تمامی حقوق برای شرکت فناوری اطلاعات راه تجارت بازار ",
    copyright2: "محفوظ است.",
    developer: " رایانیتا® ",
    unreadNotifications: "اعلان‌های خوانده نشده",
    readNotifications: "اعلان‌های خوانده شده",
    noNotifications: "اعلانی وجود ندارد!",
    nothingFound: "صفحه وجود ندارد!",
    notFoundPage: "صفحه وجود ندارد!",
    setDetails: "ثبت اطلاعات",
    SubmitInfoHint: "برای دسترسی کامل به پنل کاربری لطفا اطلاعات حساب کاربری خود را تکمیل نمایید.",
    detailsSet:"اطلاعات ثبت شد.",
    detailsSetFailed:"ثبت اطلاعات با مشکل مواجه شد.",
    detailsGetFailed:"دریافت اطلاعات با مشکل مواجه شد.",
    mobilSample:"نمونه: 09121234567",
    confirmationStatus:"تایید اطلاعات",
    descriptionConfirmationStatus:"وضعیت تایید محتوای متنی (سئو)",
    confirmationStatusDescription:"وضعیت تایید اطلاعات",
    makeProductDisable:"محصول غیر فعال است؟",
    confirmationStatusFilter:"وضعیت تایید",
    shopTypes:"نوع فروشگاه",
    userConfirmationStatus:"وضعیت تایید اطلاعات کاربر",
    confirmed:"تایید شده",
    unConfirmed:"در انتظار تایید",
    disabled:"غیرفعال",
    all:"همه",
    unCategorized:"دسته‌بندی نشده",
    addNewBrand:"افزودن ناشر جدید",
    admin: "مدیر سایت",
    accountant: "مالی و اداری",
    marketer: "بازاریاب",
    marketerConfirmationStatus: "وضعیت تایید بازاریاب",
    noMarketerFound: "بازاریابی با این کد یکتا وجود ندارد.",
    supportUser: "پشتیبانی",
    product_manager: "ادمین محصولات",
    support: "پشتیبانی",
    adminType: "مدیران سایت",
    normalType: "سایر کاربران",
    usersLog: "فعالیت‌های کاربران",
    duplicateEmail: "این شماره ایمیل قبلا استفاده شده!",
    duplicateMobile: "این شماره موبایل قبلا استفاده شده!",
    duplicateMelliCode: "این کد ملی قبلا استفاده شده!",
    someFieldsHasErrorPleaseCheckThem: "یک یا چند فیلد دارای خطا هستند، لطفا بررسی نمایید",
    duplicateName: 'این برند متعلق به شخص دیگری است.',
    dataAdded: "اطلاعات شما ایجاد شد.",
    dataAddingFailed: "در ایجاد اطلاعات مشکلی به وجود آمده است.",
    addressError: "فروشنده امکان ارسال محصول به آدرس انتخابی شما را ندارد!",
    onlyUsersCanPurchase: "ادمین سایت امکان ثبت سفارش ندارد!",
    dataEdited: "اطلاعات شما ویرایش شد.",
    categoryPublishedBefore: "دسته بندی تکراری است!",
    viewCategory: "مشاهده صفحه دسته‌بندی",
    dataEditingFailed: "در ویرایش اطلاعات مشکلی به وجود آمده است.",
    firstCheckOrdersStatus: "ابتدا وضعیت سفارش هر فروشگاه را تایید کنید!",
    deleteData: "اطلاعات حذف شد.",
    deleteDataFailed: "در حذف این اطلاعات مشکلی به وجود آمده است.",
    makeCategory: "ایجاد دسته‌بندی",
    editCategory: "ویرایش دسته‌بندی",
    makeBlogCategory: "ایجاد دسته‌بندی وبلاگ",
    editBlogCategory: "ویرایش دسته‌بندی وبلاگ",
    categoryName: "نام دسته",
    categoryParentName: "دسته والد",
    tagTitle: "تگ تایتل (سئو)",
    categories: "دسته‌بندی‌ها",
    pleaseChooseCategoriesFirst: "لطفا ابتدا دسته‌بندی را انتخاب کنید!",
    category: "دسته‌بندی‌",
    chooseCategory: "انتخاب دسته‌بندی‌",
    chooseSubCategory: "انتخاب زیر دسته‌",
    chooseMainCategory: "انتخاب دسته‌ اصلی",
    manageCategories: "مدیریت دسته‌بندی‌ها",
    manageBlogCategories: "دسته‌بندی‌ وبلاگ",
    manageBlogComments: "نظرات وبلاگ",
    manageBrands: "مدیریت ناشران",
    brandName: "نام ناشر",
    brandType: "نوع ناشر",
    brand: "ناشر",
    manageWriters: "مدیریت نویسندگان",
    writer: "نویسنده",
    makeWriter: "ایجاد نویسنده",
    editWriter: "ویرایش اطلاعات نویسنده",
    writerHelper: "نام مولف مد نظر خود را جستجو کنید!",
    addNewWriter: "افزودن مولف جدید",
    writersType: "مولف / مولفان",
    writerName: "نام مولف",
    authorsSingleDesc: "فقط یک نام درج کنید. ( در صورت نیاز به درج چند نام، آن را جداگانه وارد کنید)",
    manageNarrators: "مدیریت راوی ها",
    narrator: "راوی",
    makeNarrator: "ایجاد راوی",
    editNarrator: "ویرایش اطلاعات راوی",
    narratorHelper: "نام راوی مد نظر خود را جستجو کنید!",
    addNewNarrator: "افزودن راوی جدید",
    narratorsType: "راوی / راوی ها",
    narratorName: "نام راوی",

    manageTranslators: "مدیریت مترجمان",
    translator: "مترجم",
    editTranslator: "ویرایش اطلاعات مترجم",
    makeTranslator: "ایجاد مترجم",
    manageLabels: "مدیریت لیبل‌ها",
    labelName: "لیبل‌",
    expire_day: "تعداد روز اعتبار",
    label: "لیبل‌",
    makeLabel: "ایجاد لیبل‌",
    editLabel: "ویرایش لیبل‌",
    manageVariables: "مدیریت مشخصات کتاب‌",
    manageAttributes: "مدیریت ویژگی‌ها‌",
    chooseAttribute: "انتخاب ویژگی‌‌",
    attributes: "ویژگی‌ها‌",
    managePages: "مدیریت صفحات",
    manageDepartments: "مدیریت دپارتمان‌ها",
    manageMessages: "مدیریت پیام‌ها",
    manageAbout: "صفحه درباره‌ما",
    manageTerms: "صفحه قوانین مقررات",
    managePrivacyPolicy: "صفحه حریم خصوصی",
    manageSellerTerms: "صفحه قوانین فروشندگان",
    manageAgentTerms: "صفحه قوانین نمایندگان",
    manageContact: "فرم تماس‌ با‌ ما",
    pageDetails: "اطلاعات صفحه",
    variableIsNotConfirmed: "در انتظار تایید",
    youCantAddMoreVariablesUntileConfirmation: "امکان افزودن مشخصات کتاب بیشتر قبل از تایید موارد قبلی وجود ندارد!",
    manageVariablesOrder: "مدیریت  ترتیب مشخصات کتاب‌",
    chooseVariables: "انتخاب مشخصات کتاب‌",
    makeVariable: "ایجاد مشخصات کتاب",
    makeAttribute: "ایجاد ویژگی",
    editVariable: "ویرایش مشخصات کتاب",
    variableName: "نام مشخصه",
    attributeName: "نام ویژگی",
    attributeType: "نوع ویژگی",
    valueName: "نام مقدار",
    manageValues: "مدیریت مقدار‌ها",
    makeValue: "ایحاد مقدار",
    values: "مقدارها",
    valueColor: "رنگ مقدار",
    variables: "مشخصات کتاب‌",
    variable: "مشخصات کتاب",
    addNewVariable: "افزودن مشخصات کتاب",
    addNewVariableDescription: "برای افزودن مشخصات کتاب دکمهEnter را بزنید!",
    addYourvariableIfYouCatFind: "اگر مشخصات کتاب مد نظر خود را نمی‌یابید آن را ایجاد کنید.",
    addVariable: "افزودن مشخصات کتاب",
    user: "کاربر",
    agent: "نماینده",
    duplicateInstagram: 'این اکانت متعلق به شخص دیگری است.',
    markAsRead: 'خوانده شد!',
    dataFetchingError: 'اطلاعات مورد نظر یافت نشد!',
    activity: 'فعالیت',
    details: 'جزئیات',
    gallery: 'گالری کتاب',
    removeImage: 'حذف تصویر',
    remove: 'حذف',
    tickets: "تیکت پشتیبانی",
    bulkTicket: "تیکت گروهی",
    sendBulkTicket: "ارسال تیکت گروهی",
    manageTickets: "مدیریت تیکت‌ها",
    requestType: "دپارتمان",
    supportRequestFromDepartment: "پشتیبانی سیستم",
    referredToMe: "ارجاع شده به من",
    viewAllLists: "لیست‌ همه تیکت‌ها",
    supportRequestForProduct: "پشتیبانی کتاب",
    sendFile: "ارسال فایل",
    ticket_sender: "ارسال کننده",
    ticket_receiver: "دریافت کننده",
    ticket_title: "موضوع",
    ticket_status: "وضعیت",
    ticket_edited_at: " آخرین ارسال",
    sendMessage: "ارسال پیام",
    backToTickets: "بازگشت به تیکت‌ها",
    deleteTicket: "تیکت حذف شد!",
    deleteTicketFailed: "حذف تیکت با مشکل مواجه شد!",
    ticket_details: "اطلاعات تیکت",
    ticket_sent: "تیکت ارسال شد!",
    sendFastTicket: "ارسال سریع پیام",
    sendMessageTo: "ارسال پیام به",
    addTicket: "ارسال تیکت",
    send: "ارسال",
    messageText: "متن پیام",
    gotToTicketPage: "صفحه پیام‌ها",
    removeRequest: 'حذف درخواست',
    discountMoreThanPrice:"میزان تخفیف از کل قیمت بیشتر است",
    discount_percent:"درصد تخفیف",
    discount_percent_whole:"درصد تخفیف",
    activeWholesale:"فعال سازی فروش عمده",
    discount_price:"قیمت با تخفیف",
    discount_priceWhole:"قیمت فروش عمده با تخفیف",
    discount:"تخفیف",
    factor:"فاکتور",
    factor_number:"شماره فاکتور",
    factor_status:"وضعیت فاکتور",
    bill:"صورت حساب",
    price:"قیمت",
    x_price: "قیمت عدد X",
    priceName:"مبلغ",
    priceWhole:"قیمت فروش عمده",
    create_order:"ثبت سفارش",
    totalPriceBoth:"کل مبلغ سفارش",
    totalPrice:"قیمت کالا‌ها",
    totalDiscount:"قیمت کالا‌ها",
    totalCartPrice:"جمع سبد خرید",
    totalPriceFull:"جمع مبالغ",
    totalUserDiscounts:"جمع تخفیف‌ها",
    totalDiscounts:"سود شما از خرید",
    buyPackage:"خرید بسته افزایش",
    youDontNeedToPurchase:"شما نیازی به خرید پکیج ندارید!",
    youDontNeedToPurchaseDesc:"با توجه به حساب کاربری شما، تعداد محصول قابل ایجاد توسط شما محدود نمی‌باشد.",
    cancel:"انصراف",
    youDontHavePermission:"شما دسترسی مجاز ندارید!",
    pageNotFound:"این صفحه در دسترس نیست!",
    pressEnterAfterEachKeyword:"پس از نوشتن هر عبارت دکمه Enter را بزنید!",
    chooseBeginDate:"تاریخ شروع",
    chooseEndDate:"تاریخ پایان",
    chooseDate:"انتخاب تاریخ",
    chooseTime:"انتخاب ساعت",
    selectDate:"تایید زمان",
    doFilter:"اعمال فیلتر",
    removeFilter:"حذف فیلتر",
    noLogFound:"فعالیتی یافت نشد!",
    roleHelper:"انتخاب سطح دسترسی کاربر",
    goBackToPanel:"بازگشت به پنل",
    emailVerified:"ایمیل تایید شد!",
    emailNotVerified:"ایمیل تایید نشد!",
    visitsChart:"نمودار بازدید‌ها",
    visits:"بازدید‌ها",
    products_visits:"بازدید کتاب‌ها",
    shop_visits:"بازدید فروشگاه",
    googleAnalytics:"گوگل آنالیتیکس",
    liveUsers:"کاربران آنلاین",
    newProducts:"محصولات جدید",
    todayShops:"فروشگاه‌های جدید",
    newShops:"فروشگاه‌های جدید",
    newRegistrations:"کاربران جدید",
    todayAllUnRegisteredUsers:"بازدید‌های امروز",
    transactionType:"نوع تراکنش",
    depositMoney:"شارژ کیف پول",
    depositMoneyDescription:"مقدار مورد نظر برای شارژ کیف پول خود را در این قسمت وارد کنید.",
    withdrawMoney:"برداشت از کیف پول",
    withdrawMoneyDescription:"مقدار مورد نظر برای برداشت از کیف پول خود را در این قسمت وارد کنید.",
    deposit:"شارژ",
    withdraw:"برداشت",
    amount:"مبلغ",
    status:"وضعیت",
    index_number:"شماره ردیف",
    index:"ردیف",
    date:"تاریخ",
    describe:"شرح",
    debit:"بدهکار",
    credit:"بستانکار",
    debitCredit:"باقی مانده",
    status_description:"شرح وضعیت",
    order_status:"وضعیت سفارش",
    orderPayed:"مبلغ سفارش پرداخت شد.",
    orderPayingFailed:"در پرداخت مبلغ مشکلی وجود دارد!",
    pending:"در انتظار تایید",
    not_payed:"در انتظار پرداخت",
    removed:"حذف شده",
    commission_payed:"تسویه شده",
    commission_not_payed:"درحال بررسی ",
    commission_status:"تسویه ",
    gathering:"در انتظار تایید",
    confirmToPay:"تایید جهت پرداخت",
    removeFactorWithMessage:"لغو سفارش و اعلام به کاربر",
    ready:"درحال آماده سازی",
    sending:"درحال آماده سازی",
    done:"ارسال شده",
    donePackage:"تکمیل شده",
    orderHistory:"تاریخچه سفارش",
    rejected:"لغو سفارش",
    myWallet: "کیف پول",
    orders: "خرید‌ها",
    indexes: "ترتیب",
    ordersList: "لیست سفارشات",
    payOrder: "پرداخت سفارش‌",
    payWithWallet: "پرداخت از کیف پول",
    purchase: "پرداخت",
    withdrawRequest: "درخواست واریز",
    transactionTrackingCode: "کد پیگیری تراکنش",
    postal_code: "کد پستی",
    postalInfo: "اطلاعات پستی",
    pleaseCompleteYourPostalInfo: "لطفا اطلاعات پستی خود را تکمیل کنید!",
    postalInfoDescription: "لطفا اطلاعات پستی خود را در این قسمت وارد کنید، دکمه ثبت اطلاعات را بزنید و سپس اقدام به پرداخت کنید.",
    address: "آدرس",
    melli_code: "کد ملی",
    doctors_code: "کد نظام پزشکی",
    addRefrenceIdFirst: "ابتدا کد تراکنش را وارد کنید!",
    myWalletBalance: "موجودی کیف پول",
    balance: "موجودی",
    pleaseVerifyFirst: "لطفا ابتدا اطلاعات حساب خود را تکمیل کنید!",
    verificationDescription: "برای برداشت از کیف پول خود در سایت نیاز به تایید اطلاعات حساب بانکی دارید!",
    verificationDetails: "اطلاعات حساب بانکی",
    verificationDataSets: "اطلاعات حساب بانکی ثبت شد!",
    manageVerifications: "مدیریت حساب‌های بانکی",
    ManageUserVerification: "مدیریت حساب بانکی کاربر",
    bank_name: "نام بانک",
    branch_name: "نام شعبه",
    branch_code: "کد شعبه",
    viewUserBankInfo: "مشاهده اطلاعات حساب بانکی کاربر",
    sheba: "شماره شبا",
    account_number: "شماره حساب",
    credit_number: "شماره کارت",
    exportPaymentRequest: "گزارش درخواست‌های واریز",
    melli_card_image: "تصویر کارت ملی",
    melli_card_front: "تصویر روی کارت ملی",
    melli_card_back: "تصویر پشت کارت ملی",
    melli_card_contact: "تصویر کارت ملی رابط",
    credit_card_image: "تصویر کارت بانکی",
    credit_card_image_helper: "ارسال تصویر کارت بانکی اجباری نیست و فقط برای تطبیق اطلاعات حساب شما با مدارک هویتی می باشد.",
    credit_card_image_helper2: "شما میتوانید اطلاعات مربوط به cvv2 و تاریخ را مخدوش کرده و سپس ارسال نمایید.",
    activeStatus: "وضعیت",
    active: "فعال",
    website: "وب‌سایت",
    inactive: "غیر فعال",
    manageWallets: "مدیریت کیف پول‌ها",
    manageWalletsRequests: "مدیریت درخواست‌های واریز",
    manageUserWallet: "مدیریت تراکنش‌های کاربر",
    yourBankInfoIsActive: "اطلاعات حساب بانکی شما تایید شده و امکان برداشت از کیف پول سایت برای شما فراهم است.",
    yourBankInfoIsInchecking: "اطلاعات حساب بانکی شما در دست بررسی است.",
    payed: "پرداخت شد",
    is_payed: "پرداخت شده",
    readMore: "بیشتر بخوانید!",
    areYouSure: "آیا از انجام این کار مطمئنید؟",
    yes: "بله",
    no: "خیر",
    doYouWanaExit: "آیا قصد خروج دارید؟",
    certificationFile: "فایل جواز کسب",
    chooseFile: "انتخاب فایل",
    chooseAFile: "لطفا یک فایل انتخاب کنید!",
    welcomeUserTitle: "کاربر گرامی خوش آمدید!",
    WelcomeUserText: "لطفا اطلاعات حساب کاربری خود را تکمیل نمایید.",
    with: "با ثبت نام در این وب‌سایت ",
    withCreateShop: "با ایجاد فروشگاه در وب‌سایت ",
    withRequestingShop: "با ثبت درخواست در وب‌سایت ",
    createShop: "ایجاد فروشگاه",
    supplierRegisterText: "پس از ثبت‌نام، تکمیل اطلاعات و تایید آن فروشگاه شما ایجاد خواهد شد!",
    manageYourShop: "فروشگاه خود را مدیریت کنید",
    shopRules: "قوانین و مقررات ثبت فروشگاه",
    rules: "قوانین و مقررات",
    and: "و",
    privacyPolicy: "قوانین حریم خصوصی",
    privacyPolicyConfirmation: "آن را می‌پذیرم.",
    agentRulesConfirmation: "موافقم و آن را می‌پذیرم.",
    privacyPolicyConfirmationShop: "را می‌پذیرم.",
    privacyPolicyNotConfirmationShop: "امکان پذیرش قوانین و مقررات را ندارم!",
    rullesNotAccepted: "قوانین و مقررات تایید نشده است!",
    accepted: "تایید شد",
    registerDate: "تاریخ ثبت‌نام",
    uncompleted: "تکمیل نشده",
    userMobileIsConfirmed: "شماره موبایل کاربر تایید شده است.",
    userMobileIsNotConfirmed: "شماره موبایل کاربر تایید نشده است.",
    doYouWanaConfirm: "شماره موبایل کاربر را تایید می‌کنید؟",
    ProductIsNotOriginal: "محصول غیر اصل می‌باشد؟",
    advantages_disadvantages: "مزایا و معایب",
    advantages: "مزایا",
    productDisadvantages: "معایب محصول",
    productAdvantages: "مزایای محصول",
    disadvantages: "معایب",
    advantage: "مزیت",
    disadvantage: "عیب",
    color: "رنگ",
    string: "متن",
    variablePricing: "قیمت‌گذاری متغیر",
    simplePricing: "قیمت‌گذاری ساده",
    simplePricingDescTitle: "قیمت ثابت",
    variablePricingDescTitle: "قیمت بر اساس ویژگی محصول",
    attributeChooserTitle: "های مورد نظر خود را انتخاب نمایید.",
    doYouWantToChangePricingType: "آیا می‌خواهید نوع قیمت‌گذاری خود را تغییر دهید؟",
    help: "راهنما",
    understood: "متوجه شدم!",
    pricingDiferences: "تفاوت انواع قیمت‌گذاری",
    simplePricingDesc: "اگر یک نوع از این محصول دارید و تفاوتی در تعداد موجودی و قیمت ندارد از این گزینه استفاده کنید.",
    variablePricingDesc: "اگر چند نوع از این محصول دارید و در تعداد موجودی و قیمت تفاوت وجود دارد از این گزینه استفاده کنید.",
    warranty: "گارانتی",
    inventory: "موجودی",
    inventory_for_wholesale: "حداقل فروش عمده",
    inventoryWholeSaleDesc: "حداقل تعداد قابل فروش به صورت عمده",
    inventoryDesc: "تعداد موجودی کالا",
    has_discount_validity: "مدت زمان تخفیف محدود است",
    has_discount_validity_desc: "(در صورت فعال نمودن این گزینه میتوانید تخفیف خود را زمان دار کنید و شمارش معکوس آن را نمایش دهید)",
    transfer_time: "زمان ارسال کالا",
    modifyPricing: "ویرایش قیمت‌گذاری",
    managePricing: "مدیریت قیمت‌گذاری",
    headerTemplate: "هدر و منو سایت",
    headerTemplateDesc: "تنظیمات مربوط به هدر و منو‌‌های سایت",
    chooseHeader: "انتخاب هدر",
    chooseHeaderText: "در این قسمت می‌توانید طراحی هدر سایت خود را به طور کامل تغییر دهید.",
    chooseFooter: "انتخاب فوتر",
    chooseFooterText: "در این قسمت می‌توانید طراحی فوتر سایت خود را به طور کامل تغییر دهید.",
    manageHeader: "مدیریت هدر",
    manageFooter: "مدیریت فوتر",
    manageMenu: "مدیریت منو",
    footerCertifications: "نماد‌های فوتر",
    makeHeaderMenu: "تنظیمات منو اصلی سایت",
    makeHeaderMenuText: "در این قسمت می‌توانید المان‌های منوی اصلی سایت را به طور کامل تغییر دهید. (این منو در هدر سایت و هدر پنل نمایش داده می‌شود).",
    makeFooterMenu: "تنظیمات منو پایینی سایت",
    makeFooterMenuText: "در این قسمت می‌توانید المان‌های منوی پایینی سایت را به طور کامل تغییر دهید.",
    footerTemplate: "فوتر و منو پایین",
    footerTemplateDesc: "تنظیمات مربوط به فوتر و منو‌‌ پایینی سایت",
    footerCertificationTitle: "کد مربوط به نماد ها",
    footerCertificationText: "در این قسمت می‌توانید کد‌های دریافتی از سازمان های مختلف مانند نماد اعتماد، رسانه‌های دیجیتال و... را قرار دهید.",
    mapScriptTitle: "کد نقشه",
    mapScriptText: "در این قسمت می‌توانید کد‌های دریافتی از پلتفرم های مختلف نمایش نقشه مانند Google Map را قرار دهید، تا در صفحه تماس نشان داده شوند.",
    home_page_top_banner: "بنر بالا صفحه اصلی",
    home_page_cta: "دکمه فراخوان صفحه اصلی",
    home_page_twin_right: "بنر راست دوتایی صفحه اصلی ",
    home_page_twin_left: "بنر چپ دوتایی صفحه اصلی",
    categories_banner: "بنر دسته بندی‌ها",
    product_page_banner: "بنر بالای صفحه تک محصول",
    product_inside_banner: "بنر داخل صفحه تک محصول",
    home_single_banners: "بنر‌های تکی صفحه اصلی",
    home_left_banners: "بنر‌های سمت چپ صفحه اصلی",
    app_home_banners: "بنر‌های صفحه اصلی اپلیکیشن",
    home_right_banners: "بنر‌های سمت راست صفحه اصلی",
    home_top_banners: "بنر‌های بالای صفحه اصلی",
    footer_icon_text_1: "متن و آیکون فوتر ۱",
    footer_icon_text_2: "متن و آیکون فوتر ۲",
    footer_icon_text_3: "متن و آیکون فوتر ۳",
    footer_icon_text_4: "متن و آیکون فوتر ۴",
    normalShop: "فروشنده عادی",
    storeShop: "فروشگاه کتاب",
    physical_storeShop: "فروشگاه فیزیکی",
    virtual_storeShop: "فروشگاه مجازی",
    distributionShop: "شرکت پخش",
    publisherShop: "انتشارات",
    normalShopDesc: "شامل اشخاص حقیقی که شامل دسته بندی بالا نیستند",
    storeShopDesc: "فروشگاه کتاب",
    physical_storeShopDesc: "شامل اشخاص حقیقی و حقوقی دارای پروانه کسب کتابفروشی",
    virtual_storeShopDesc: "شامل فروشگاه‌های فعال در فضای مجازی و شبکه‌های اجتماعی",
    distributionShopDesc: "شامل اشخاص حقیقی و حقوقی دارای مجوز پخش کتاب",
    publisherShopDesc: "شامل اشخاص حقیقی و حقوقی دارای مجوز انتشار کتاب",
    shopType: "نوع فروشگاه",
    identity: "نوع شخصیت",
    real: "شخصیت حقیقی",
    legal: "شخصیت حقوقی",
    new: "نو",
    worked: "دست دوم",
    workedBook: "کتاب دست دوم",
    situation: "وضعیت کتاب",
    unique_code: "کد یونیک",
    virtual: "مجازی",
    physically: "نوع کتاب",
    physical: "کتاب کاغذی",
    audiobook: "کتاب صوتی",
    ebook: "کتاب الکترونیکی",
    rent: "کرایه ",
    rentDesc: "کرایه کتاب به مدت",
    translatorName: "نام مترجم",
    aboutAuthor: "درباره نویسنده",
    translatorsType: "مترجم / مترجمان",
    addNewTranslator: "افزودن مترجم جدید",
    makePerson: "افزودن شخص",
    translatorHelper: "نام مترجم مد نظر خود را جستجو کنید!",
    noResultFound: "نتیجه‌ای یافت نشد!",
    submit_review: "ثبت دیدگاه",
    submit_review_title: "توضیحات تکمیلی و ثبت دیدگاه",
    overalDescription: "توضیحات تکمیلی",
    review_submitted: "دیدگاه شما ثبت شد!",
    shopInfo: "اطلاعات فروشگاه",
    owningInfo: "اطلاعات مالکیت",
    review_submitted_text: "پس از تایید کارشناسان سایت، قابل نمایش خواهد بود.",
    attentionForPricing: "لطفا دقت کنید که تمامی اطلاعات این کتاب با کتاب شما همخوانی داشته باشد، در غیر این صورت محصول، تازه ایجاد کنید.",
    manageFestivals: "مدیریت جشنواره‌ها",
    festival_name: "نام جشنواره",
    festival_starts_at: "زمان شروع",
    festival_ends_at: "زمان پایان",
    makeFestival: "ایجاد جشنواره",
    editFestival: "ویرایش جشنواره",
    festivalBanner: "بنر جشنواره",
    festivalThinBanner: "بنر  باریک جشنواره",
    festivalDescription: "توضیحات",
    festivals: "جشنواره‌ها",
    festivalDescriptionDesc: "توضیحات مربوط به جشنواره",
    activeFestivals: "جشنواره‌های فعال",
    viewFestivalPage: "مشاهده صفحه جشنواره",
    participate: "مشارکت در جشنواره",
    participateDesc: "کتاب‌هایی را که می‌خواهید در این جشنواره شرکت‌ کنند انتخاب نمایید!",
    chooseAll: "انتخاب همه",
    orderSent: "ارسال سفارش",
    submitShippingInfo: "ثبت اطلاعات ارسال",
    shipping_code: "کد رهگیری پستی",
    changeOrderStatus: "تغییر وضعیت سفارش",
    pay_to_shop_text1: "با توجه به ارسال سفارش، در تاریخ ",
    pay_to_shop_text2: "و یا پس از تایید خریدار، با شما تسویه حساب خواهد شد. ",
    pay_to_shop_text_admin: "، با فروشنده تسویه حساب خواهد شد. ",
    pay_to_shop_received_text1: "با توجه به تایید خریدار، مرسوله تحویل داده شده است، شما می‌توانید با فروشنده تسویه حساب نمایید و یا در تاریخ ",
    pay_to_shop_received_text2: "به صورت اتوماتیک با فروشنده تسویه خواهد شد. ",

    dublicatedData: "نام وارد شده قبلا در سیستم ثبت شده است، آن را جستجو و انتخاب نمایید.",
    sendingList: "لیست مرسوله‌ها ",
    submitReceivngBox: "تایید دریافت مرسوله",
    submitShipmentFailure: "عدم دریافت مرسوله",
    submitReceivngBoxShort: "تایید دریافت",
    submitReceivngBoxQ: "در صورت تایید دریافت، با فروشنده تسویه حساب می‌شود",
    shipmentFailureBoxShort: "عدم دریافت مرسوله",
    ShipmentFailureBoxQ: "در صورتی که هنوز مرسوله این سفارش را دریافت نکرده‌اید، تایید کنید",
    received: "تحویل شده به خریدار",
    myBooks: "کتاب‌های من",
    youReachedYourLimit: "با توجه به محدودیت ایجاد محصول شما، امکان ایجاد محصولات وجود ندارد",
    coverSizeGuide: "سایز تصویر باید 1320 در 250 پیکسل باشد",
    chooseHour: " ساعت",
    chooseMinute: " دقیقه",
    shipmentFailureNotif: "تسویه حساب اتوماتیک فروشنده غیر فعال شد",
    auto_pay_off_text: "تسویه حساب اتوماتیک فروشنده غیر فعال است",
    autoPayIsOff: "با توجه به غیر فعال بودن تسویه اتوماتیک برای شما، پس از تایید دریافت مرسوله توسط خریدار با شما تسویه حساب خواهد شد.",
    ExcelImportBtnLabel: "بارگذاری فایل اکسل",
    coverMobileSizeGuide: "سایز تصویر باید 750 در 250 پیکسل باشد",
    cover_mobile: "کاور فروشگاه (در موبایل)",
    normal_publisher: "ناشر عادی",
    audio_publisher: "ناشر صوتی",
    activate: "فعال سازی",
    activateSound: "جهت فعال سازی صدای اعلان کلیک کنید!",
    accountingReport: "گزارش حسابداری",
    exportInExcel: "دریافت خروجی اکسل",
    print: "پرینت",
    brief: "عنوان تکمیلی",
    all_shops: "همه فروشگاه ها",
    all_customers: "همه مشتریان",
    ordered_customers: "مشتریان دارای سفارش",
    bulkTicketTitle: "هشدار!",
    bulkTicketDescription: "پس از ارسال تیکت امکان برگرداندن آن‌ها وجود ندارد. در صورت بالا بودن تعداد کاربران انتخابی، این عمل زمان بر می‌شود. لطفا تا پس از نمایش اعلان ارسال موفق در صفحه باقی بمانید.",
    sendRawFile: "ارسال فایل خام کتاب",
    sendRawFileDesc: "در صورت نیاز به تبدیل فایل خام شما به نسخه EPUB توسط پنجره، فایل خام را از این طریق ارسال نمایید.",
    hide_book_file: "عدم نمایش فایل کتاب به فروشنده",
    courierShipmentNotic: "پس از تحویل مرسوله به پیک، دکمه تغییر وضعیت سفارش را بزنید.",
    faqs: "سوالات متداول",
    question: "پرسش",
    answer: "پاسخ",
    addNewFAQ: "پرسش جدید",
    addNewFAQDesc: "ایجاد پرسش و پاسخ جدید",
};

export const DataTableLocalization = {
    pagination: {
        labelDisplayedRows: '{from}-{to} از {count}',
        labelRowsSelect: "ردیف",
        labelRowsPerPage: "تعداد ردیف‌ها در هر صفحه",
        firstAriaLabel: "صفحه اول",
        firstTooltip: "صفحه اول",
        previousAriaLabel: "صفحه قبل",
        previousTooltip: "صفحه قبل",
        nextAriaLabel: "صفحه بعد",
        nextTooltip: "صفحه بعد",
        lastAriaLabel: "صفحه آخر",
        lastTooltip: "صفحه آخر",
    },
    toolbar: {
        nRowsSelected: '{0} ردیف انتخاب شده',
        searchTooltip: 'جستجو',
        searchPlaceholder: 'جستجو',
        exportTitle: "دریافت فایل خروجی",
        exportAriaLabel: "دریافت فایل خروجی",
        exportCSVName: "دریافت خروجی CSV",
        exportPDFName: "",

    },
    header: {
        actions: <SettingsIcon/>
    },
    body: {
        emptyDataSourceMessage:  'محتوایی برای نمایش وجود ندارد!',
        addTooltip: 'افزودن',
        deleteTooltip: 'پاک کن',
        editTooltip: 'ویرایش سریع',

        filterRow: {
            filterTooltip: 'فیلتر',
        },
        editRow:{
            deleteText: 'آیا از حذف این ردیف مطمئنید؟',
            cancelTooltip: 'لغو',
            saveTooltip: 'ذخیره',
        }
    }
};
